{
  "about.blocks": "Modererte tenarar",
  "about.contact": "Kontakt:",
  "about.default_locale": "Standard",
  "about.disclaimer": "Mastodon er gratis programvare med open kjeldekode, og eit varemerke frå Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Årsaka er ikkje tilgjengeleg",
  "about.domain_blocks.preamble": "Mastodon gjev deg som regel lov til å sjå innhald og samhandla med brukarar frå alle andre tenarar i allheimen. Dette er unntaka som er valde for akkurat denne tenaren.",
  "about.domain_blocks.silenced.explanation": "Med mindre du leiter den opp eller fylgjer profiler på tenaren, vil du vanlegvis ikkje sjå profilar og innhald frå denne tenaren.",
  "about.domain_blocks.silenced.title": "Avgrensa",
  "about.domain_blocks.suspended.explanation": "Ingen data frå denne tenaren vert handsama, lagra eller sende til andre, noko som gjer det umogeleg å samhandla eller kommunisera med brukarar på denne tenaren.",
  "about.domain_blocks.suspended.title": "Utestengd",
  "about.language_label": "Språk",
  "about.not_available": "Denne informasjonen er ikkje gjort tilgjengeleg på denne tenaren.",
  "about.powered_by": "Desentraliserte sosiale medium drive av {mastodon}",
  "about.rules": "Tenarreglar",
  "account.account_note_header": "Personleg notat",
  "account.activity": "Aktivitet",
  "account.add_note": "Legg til eit personleg notat",
  "account.add_or_remove_from_list": "Legg til eller fjern frå lister",
  "account.badges.admin": "Admin",
  "account.badges.blocked": "Blokkert",
  "account.badges.bot": "Robot",
  "account.badges.domain_blocked": "Blokkert domene",
  "account.badges.group": "Gruppe",
  "account.badges.muted": "Dempa",
  "account.badges.muted_until": "Dempa til {until}",
  "account.block": "Blokker @{name}",
  "account.block_domain": "Skjul alt frå {domain}",
  "account.block_short": "Blokker",
  "account.blocked": "Blokkert",
  "account.cancel_follow_request": "Trekk attende fylgeførespurnad",
  "account.copy": "Kopier lenka til profilen",
  "account.direct": "Nemn @{name} privat",
  "account.disable_notifications": "Slutt å varsle meg når @{name} skriv innlegg",
  "account.edit_note": "Rediger det personlege notatet",
  "account.edit_profile": "Rediger profil",
  "account.edit_profile_short": "Rediger",
  "account.enable_notifications": "Varsle meg når @{name} skriv innlegg",
  "account.endorse": "Vis på profilen",
  "account.familiar_followers_many": "Fylgt av {name1}, {name2}, og {othersCount, plural, one {ein annan du kjenner} other {# andre du kjenner}}",
  "account.familiar_followers_one": "Fylgt av {name1}",
  "account.familiar_followers_two": "Fylgt av {name1} og {name2}",
  "account.featured": "Utvald",
  "account.featured.accounts": "Profilar",
  "account.featured.collections": "Samlingar",
  "account.featured.new_collection": "Ny samling",
  "account.field_overflow": "Vis heile innhaldet",
  "account.filters.all": "All aktivitet",
  "account.filters.boosts_toggle": "Vis framhevingar",
  "account.filters.posts_boosts": "Innlegg og framhevingar",
  "account.filters.posts_only": "Innlegg",
  "account.filters.posts_replies": "Innlegg og svar",
  "account.filters.replies_toggle": "Vis svar",
  "account.follow": "Fylg",
  "account.follow_back": "Fylg tilbake",
  "account.follow_back_short": "Fylg tilbake",
  "account.follow_request": "Be om å fylgja",
  "account.follow_request_cancel": "Avbryt førespurnaden",
  "account.follow_request_cancel_short": "Avbryt",
  "account.follow_request_short": "Førespurnad",
  "account.followers": "Fylgjarar",
  "account.followers.empty": "Ingen fylgjer denne brukaren enno.",
  "account.followers_counter": "{count, plural, one {{counter} fylgjar} other {{counter} fylgjarar}}",
  "account.followers_you_know_counter": "{counter} du kjenner",
  "account.following": "Fylgjer",
  "account.following_counter": "{count, plural, one {fylgjer {counter}} other {fylgjer {counter}}}",
  "account.follows.empty": "Denne brukaren fylgjer ikkje nokon enno.",
  "account.follows_you": "Fylgjer deg",
  "account.go_to_profile": "Gå til profil",
  "account.hide_reblogs": "Gøym framhevingar frå @{name}",
  "account.in_memoriam": "Til minne om.",
  "account.join_modal.day": "Dag",
  "account.join_modal.me": "Du vart medlem av {server} den",
  "account.join_modal.me_anniversary": "God allheimsbursdag! Du vart medlem av {server} den",
  "account.join_modal.me_today": "Det er fyrste dagen din på {server}!",
  "account.join_modal.other": "{name} vart medlem av {server} den",
  "account.join_modal.other_today": "{name} har sin fyrste dag på {server}!",
  "account.join_modal.share.celebrate": "Skriv eit jubileumsinnlegg",
  "account.join_modal.share.intro": "Skriv eit introduksjonsinnlegg",
  "account.join_modal.share.welcome": "Skriv eit velkomstinnlegg",
  "account.join_modal.years": "{number, plural, one {år} other {år}}",
  "account.joined_short": "Vart med",
  "account.languages": "Endre språktingingar",
  "account.last_active": "Sist aktiv",
  "account.link_verified_on": "Eigarskap for denne lenkja vart sist sjekka {date}",
  "account.locked_info": "Denne kontoen er privat. Eigaren kan sjølv velja kven som kan fylgja han.",
  "account.media": "Media",
  "account.mention": "Nemn @{name}",
  "account.menu.add_to_list": "Legg til liste…",
  "account.menu.block": "Blokker konto",
  "account.menu.block_domain": "Blokker {domain}",
  "account.menu.copied": "Kopierte kontolenka til utklippstavla",
  "account.menu.copy": "Kopier lenka",
  "account.menu.direct": "Nemn privat",
  "account.menu.hide_reblogs": "Gøym framhevingar på tidslina",
  "account.menu.mention": "Omtale",
  "account.menu.mute": "Demp konto",
  "account.menu.note.description": "Berre synleg for deg",
  "account.menu.open_original_page": "Vis på {domain}",
  "account.menu.remove_follower": "Fjern fylgjar",
  "account.menu.report": "Rapporter kontoen",
  "account.menu.share": "Del…",
  "account.menu.show_reblogs": "Vis framhevingar på tidslina",
  "account.menu.unblock": "Fjern blokkeringa av kontoen",
  "account.menu.unblock_domain": "Opphev blokkeringa av {domain}",
  "account.menu.unmute": "Avdemp kontoen",
  "account.moved_to": "{name} seier at deira nye konto no er:",
  "account.mute": "Demp @{name}",
  "account.mute_notifications_short": "Demp varslingar",
  "account.mute_short": "Demp",
  "account.muted": "Målbunden",
  "account.mutual": "De fylgjer kvarandre",
  "account.name.copy": "Kopier brukaradressa",
  "account.name.help.domain": "{domain} er tenaren som lagrar brukarprofilen og innlegga.",
  "account.name.help.domain_self": "{domain} er tenaren som lagrar brukarprofilen og innlegga dine.",
  "account.name.help.footer": "Du kan senda epost til folk som bruker ulike eposttenester, og nett slik er det med Mastodon og resten av Allheimen òg: Du kan samhandla med folk her eller andre stader uansett kva tenar dei bruker.",
  "account.name.help.header": "Ei brukaradresse er som ei epostadresse",
  "account.name.help.username": "{username} er brukarnamnet til denne kontoen på tenaren deira. Folk på andre tenarar kan ha same brukarnamnet.",
  "account.name.help.username_self": "{username} er brukarnamnet ditt på denne tenaren. Folk på andre tenarar kan ha same brukarnamnet.",
  "account.name_info": "Kva tyder dette?",
  "account.no_bio": "Inga skildring er gjeven.",
  "account.node_modal.callout": "Berre du kan sjå personlege notat.",
  "account.node_modal.edit_title": "Rediger det personlege notatet",
  "account.node_modal.error_unknown": "Klarte ikkje å lagra notatet",
  "account.node_modal.field_label": "Personleg notat",
  "account.node_modal.save": "Lagre",
  "account.node_modal.title": "Legg til eit personleg notat",
  "account.note.edit_button": "Rediger",
  "account.note.title": "Personleg notat (berre synleg for deg)",
  "account.open_original_page": "Opne originalsida",
  "account.pending": "Ventar",
  "account.posts": "Tut",
  "account.remove_from_followers": "Fjern {name} frå fylgjarane dine",
  "account.report": "Rapporter @{name}",
  "account.requested_follow": "{name} har bedt om å få fylgja deg",
  "account.share": "Del @{name} sin profil",
  "account.show_reblogs": "Vis framhevingar frå @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} innlegg} other {{counter} innlegg}}",
  "account.timeline.pinned": "Festa",
  "account.timeline.pinned.view_all": "Sjå alle dei festa innlegga",
  "account.unblock": "Stopp blokkering av @{name}",
  "account.unblock_domain": "Stopp blokkering av domenet {domain}",
  "account.unblock_domain_short": "Fjern blokkering",
  "account.unblock_short": "Stopp blokkering",
  "account.unendorse": "Ikkje vis på profil",
  "account.unfollow": "Slutt å fylgja",
  "account.unmute": "Opphev demping av @{name}",
  "account.unmute_notifications_short": "Opphev demping av varslingar",
  "account.unmute_short": "Opphev demping",
  "account_edit.advanced_settings.bot_hint": "Varsla andre om at denne kontoen for det meste er automatisert og truleg ikkje blir sjekka jamnleg",
  "account_edit.advanced_settings.bot_label": "Automatisert konto",
  "account_edit.advanced_settings.title": "Avanserte innstillingar",
  "account_edit.bio.add_label": "Skriv om deg sjølv",
  "account_edit.bio.edit_label": "Rediger bio",
  "account_edit.bio.placeholder": "Skriv ei kort innleiing slik at andre kan sjå kven du er.",
  "account_edit.bio.title": "Om meg",
  "account_edit.bio_modal.add_title": "Skriv om deg sjølv",
  "account_edit.bio_modal.edit_title": "Endre bio",
  "account_edit.column_button": "Ferdig",
  "account_edit.column_title": "Rediger profil",
  "account_edit.custom_fields.add_label": "Legg til felt",
  "account_edit.custom_fields.edit_label": "Rediger felt",
  "account_edit.custom_fields.placeholder": "Legg til pronomen, lenkjer eller kva du elles vil dela.",
  "account_edit.custom_fields.reorder_button": "Omorganiser felt",
  "account_edit.custom_fields.tip_content": "Du kan auka truverdet til Mastodon-kontoen din ved å stadfesta lenker til nettstader du eig.",
  "account_edit.custom_fields.tip_title": "Tips: Legg til stadfesta lenker",
  "account_edit.custom_fields.title": "Eigne felt",
  "account_edit.custom_fields.verified_hint": "Korleis legg eg til ei stadfesta lenke?",
  "account_edit.display_name.add_label": "Legg til synleg namn",
  "account_edit.display_name.edit_label": "Endre synleg namn",
  "account_edit.display_name.placeholder": "Det synlege namnet ditt er det som syner på profilen din og i tidsliner.",
  "account_edit.display_name.title": "Synleg namn",
  "account_edit.featured_hashtags.edit_label": "Legg til emneknaggar",
  "account_edit.featured_hashtags.placeholder": "Hjelp andre å finna og få rask tilgang til favorittemna dine.",
  "account_edit.featured_hashtags.title": "Utvalde emneknaggar",
  "account_edit.field_actions.delete": "Slett felt",
  "account_edit.field_actions.edit": "Rediger felt",
  "account_edit.field_delete_modal.confirm": "Vil du sletta dette tilpassa feltet? Du kan ikkje angra.",
  "account_edit.field_delete_modal.delete_button": "Slett",
  "account_edit.field_delete_modal.title": "Slett tilpassa felt?",
  "account_edit.field_edit_modal.add_title": "Legg til eit tilpassa felt",
  "account_edit.field_edit_modal.discard_confirm": "Forkast",
  "account_edit.field_edit_modal.discard_message": "Du har ulagra endringar. Er du sikker på at du vil forkasta dei?",
  "account_edit.field_edit_modal.edit_title": "Rediger tilpassa felt",
  "account_edit.field_edit_modal.length_warning": "Du har nåd den tilrådde maksgrensa for teikn. Mobilbrukarar ser truleg ikkje heile feltet.",
  "account_edit.field_edit_modal.link_emoji_warning": "Me rår frå å bruka eigne smilefjes kombinert med adresser. Tilpassa felt som inneheld båe, vil syna som berre tekst i staden for ei lenke, slik at lesarane ikkje blir forvirra.",
  "account_edit.field_edit_modal.name_hint": "Til dømes «Personleg nettstad»",
  "account_edit.field_edit_modal.name_label": "Etikett",
  "account_edit.field_edit_modal.url_warning": "Skriv {protocol} i starten for å leggja til ei lenke.",
  "account_edit.field_edit_modal.value_hint": "Til dømes «https://nettstad.no»",
  "account_edit.field_edit_modal.value_label": "Verdi",
  "account_edit.field_reorder_modal.drag_cancel": "Du avbraut draginga. Feltet «{item}» vart sleppt.",
  "account_edit.field_reorder_modal.drag_end": "Feltet «{item}» vart sleppt.",
  "account_edit.field_reorder_modal.drag_instructions": "For å flytta eigne felt, trykkjer du mellomrom eller enter. Bruk piltastane når du dreg for å flytta feltet opp eller ned. Trykk mellomrom eller enter ein gong til for å sleppa feltet på den nye plassen, eller trykk escape for å avbryta.",
  "account_edit.field_reorder_modal.drag_move": "Feltet «{item}» vart flytt.",
  "account_edit.field_reorder_modal.drag_over": "Feltet «{item}» vart flytt over «{over}».",
  "account_edit.field_reorder_modal.drag_start": "Plukka opp feltet «{item}».",
  "account_edit.field_reorder_modal.handle_label": "Dra feltet «{item}»",
  "account_edit.field_reorder_modal.title": "Flytt felt",
  "account_edit.image_alt_modal.add_title": "Legg til skildring",
  "account_edit.image_alt_modal.details_content": "JA: <ul> <li>Skildre deg sjølv på biletet</li> <li>Bruk tredjeperson (til dømes «Anne» i staden for «meg»)</li> <li>Skriv stutt</li> </ul> NEI: <ul> <li>Start med «bilete av». Skjermlesarar treng ikkje det.</li> </ul> DØME: <ul> <li>«Anne har på seg ei grøn skjorte og briller»</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Tips: Skrildre profilbilete",
  "account_edit.image_alt_modal.edit_title": "Rediger skildring",
  "account_edit.image_alt_modal.text_hint": "Skildringar hjelper folk som bruker skjermlesarar å forstå deg.",
  "account_edit.image_alt_modal.text_label": "Skildring",
  "account_edit.image_delete_modal.confirm": "Vil du sletta dette biletet? Du kan ikkje angra.",
  "account_edit.image_delete_modal.delete_button": "Slett",
  "account_edit.image_delete_modal.title": "Slett bilete?",
  "account_edit.image_edit.add_button": "Legg til bilete",
  "account_edit.image_edit.alt_add_button": "Legg til skildring",
  "account_edit.image_edit.alt_edit_button": "Rediger skildring",
  "account_edit.image_edit.remove_button": "Fjern bilete",
  "account_edit.image_edit.replace_button": "Erstatt bilete",
  "account_edit.item_list.delete": "Slett {name}",
  "account_edit.item_list.edit": "Rediger {name}",
  "account_edit.name_modal.add_title": "Legg til synleg namn",
  "account_edit.name_modal.edit_title": "Endre synleg namn",
  "account_edit.profile_tab.button_label": "Tilpass",
  "account_edit.profile_tab.hint.description": "Desse innstillingane tilpassar kva folk ser på {server} i dei offisielle appane, men dei gjeld ikkje dermed folk på andre tenarar og tredjepartsappar.",
  "account_edit.profile_tab.hint.title": "Visinga er likevel ulik",
  "account_edit.profile_tab.show_featured.description": "«Utvalt» er ei tilleggsfane der du kan syna fram andre kontoar.",
  "account_edit.profile_tab.show_featured.title": "Vis «Utvalt»-fana",
  "account_edit.profile_tab.show_media.description": "«Medium» er ei tilleggsfane for innlegga dine som inneheld bilete eller filmar.",
  "account_edit.profile_tab.show_media.title": "Vis «Medium»-fana",
  "account_edit.profile_tab.show_media_replies.description": "Når medium-fana er i bruk, syner ho både innlegga dine og svar på andre folk sine innlegg.",
  "account_edit.profile_tab.show_media_replies.title": "Ta med svar i «Medium»-fana",
  "account_edit.profile_tab.show_relations.description": "Syner fylgjarane dine og dei du fylgjer til andre brukarar til andre brukarar på profilen din. Folk vil framleis kunna sjå om du fylgjer dei.",
  "account_edit.profile_tab.show_relations.title": "Vis «fylgjarar» og «dei du fylgjer»",
  "account_edit.profile_tab.subtitle": "Tilpass korleis profilen din ser ut.",
  "account_edit.profile_tab.title": "Innstillingar for profilvising",
  "account_edit.save": "Lagre",
  "account_edit.upload_modal.back": "Tilbake",
  "account_edit.upload_modal.done": "Ferdig",
  "account_edit.upload_modal.next": "Neste",
  "account_edit.upload_modal.step_crop.zoom": "Forstørre",
  "account_edit.upload_modal.step_upload.button": "Sjå gjennom filer",
  "account_edit.upload_modal.step_upload.dragging": "Slepp for å lasta opp",
  "account_edit.upload_modal.step_upload.header": "Vel eit bilete",
  "account_edit.upload_modal.step_upload.hint": "WEBP, PNG, GIF eller JPG-format, opp til {limit}MB.{br}Biletet blir skalert til {width}*{height} punkt.",
  "account_edit.upload_modal.title_add.avatar": "Legg til profilbilete",
  "account_edit.upload_modal.title_add.header": "Legg til forsidebilete",
  "account_edit.upload_modal.title_replace.avatar": "Byt ut profilbilete",
  "account_edit.upload_modal.title_replace.header": "Byt ut forsidebilete",
  "account_edit.verified_modal.details": "Auk truverdet til Mastodon-profilen din ved å stadfesta lenker til personlege nettstader. Slik verkar det:",
  "account_edit.verified_modal.invisible_link.details": "Den viktige delen er rel=\"me\", som på nettstader med brukargenerert innhald vil hindra at andre kan låst som dei er deg. Du kan til og med bruka link i staden for {tag} i toppteksten til sida, men HTML-koden må vera tilgjengeleg utan å måtte køyra JavaScript.",
  "account_edit.verified_modal.invisible_link.summary": "Korleis gjer eg lenka usynleg?",
  "account_edit.verified_modal.step1.header": "Kopier HTML-koden under og lim han inn i toppfeltet på nettstaden din",
  "account_edit.verified_modal.step2.details": "Viss du allereie har lagt til nettsida di i eit tilpassa felt, må du sletta ho og leggja ho til på nytt for å setja i gang stadfestinga.",
  "account_edit.verified_modal.step2.header": "Legg til nettstaden din som eige felt",
  "account_edit.verified_modal.title": "Korleis legg eg til ei stadfesta lenke",
  "account_edit_tags.add_tag": "Legg til #{tagName}",
  "account_edit_tags.column_title": "Endre merkelappar",
  "account_edit_tags.help_text": "Utvalde emneknaggar hjelper folk å oppdaga og samhandla med profilen din. Dei blir viste som filter på aktivitetsoversikta på profilsida di.",
  "account_edit_tags.max_tags_reached": "Du har nådd grensa for kor mange emneknaggar du kan ha.",
  "account_edit_tags.search_placeholder": "Skriv ein emneknagg…",
  "account_edit_tags.suggestions": "Framlegg:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# innlegg} other {# innlegg}}",
  "account_list.hidden_notice": "Berre du ser dette. Gå til <link>{page} > {modal} > {field}</link> for å syna lista til andre.",
  "account_list.total": "{total, plural, one {# konto} other {# kontoar}}",
  "account_note.placeholder": "Klikk for å leggja til merknad",
  "admin.dashboard.daily_retention": "Mengda brukarar aktive ved dagar etter registrering",
  "admin.dashboard.monthly_retention": "Mengda brukarar aktive ved månader etter registrering",
  "admin.dashboard.retention.average": "Gjennomsnitt",
  "admin.dashboard.retention.cohort": "Registrert månad",
  "admin.dashboard.retention.cohort_size": "Nye brukarar",
  "admin.impact_report.instance_accounts": "Kontoprofilar dette vil sletta",
  "admin.impact_report.instance_followers": "Fylgjarar som brukarane våre ville mista",
  "admin.impact_report.instance_follows": "Fylgjarar som brukarane deira ville mista",
  "admin.impact_report.title": "Samandrag av konsekvensane",
  "alert.rate_limited.message": "Ver venleg å prøv på nytt etter {retry_time, time, medium}.",
  "alert.rate_limited.title": "Redusert kapasitet",
  "alert.unexpected.message": "Det oppstod eit uventa problem.",
  "alert.unexpected.title": "Oi sann!",
  "alt_text_badge.title": "Alternativ tekst",
  "alt_text_modal.add_alt_text": "Legg til alternativ tekst",
  "alt_text_modal.add_text_from_image": "Legg til tekst frå biletet",
  "alt_text_modal.cancel": "Avbryt",
  "alt_text_modal.change_thumbnail": "Endre miniatyrbilete",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Skriv ei skildring for menneske med høyrselsnedsetjingar…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Skriv ei skildring for menneske med synsnedsetjingar…",
  "alt_text_modal.done": "Ferdig",
  "announcement.announcement": "Kunngjering",
  "annual_report.announcement.action_build": "Set saman min Årstodon",
  "annual_report.announcement.action_dismiss": "Nei takk",
  "annual_report.announcement.action_view": "Sjå min Årstodon",
  "annual_report.announcement.description": "Sjå meir om kva du har gjort på Mastodon siste året.",
  "annual_report.announcement.title": "Årstodon {year} er her",
  "annual_report.nav_item.badge": "Nytt",
  "annual_report.shared_page.donate": "Doner",
  "annual_report.shared_page.footer": "Laga med {heart} av Mastodon-laget",
  "annual_report.shared_page.footer_server_info": "{username} bruker {domain}, som er eitt av mange nettsamfunn som bruker Mastodon.",
  "annual_report.summary.archetype.booster.desc_public": "{name} var på jakt etter innlegg å framheva, og var treffsikker i å forsterka andre.",
  "annual_report.summary.archetype.booster.desc_self": "Du var på jakt etter innlegg å framheva, og var treffsikker i å forsterka andre.",
  "annual_report.summary.archetype.booster.name": "Skyttaren",
  "annual_report.summary.archetype.die_drei_fragezeichen": "Detektiven",
  "annual_report.summary.archetype.lurker.desc_public": "Me veit at {name} var der ute ein stad og brukte Mastodon på sin eigen, stillferdige måte.",
  "annual_report.summary.archetype.lurker.desc_self": "Me veit du var der ute ein stad og brukte Mastodon på din eigen, stillferdige måte.",
  "annual_report.summary.archetype.lurker.name": "Stoikaren",
  "annual_report.summary.archetype.oracle.desc_public": "{name} skreiv fleire innlegg enn svar, og heldt Mastodon fersk og framoverlent.",
  "annual_report.summary.archetype.oracle.desc_self": "Du skreiv fleire innlegg enn svar, og heldt dermed Mastodon fersk og framoverlent.",
  "annual_report.summary.archetype.oracle.name": "Orakelet",
  "annual_report.summary.archetype.pollster.desc_public": "{name} laga fleire meiningsmålingar enn andre typar innlegg, og bidrog til nyfikne på Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Du laga fleire meiningsmålingar enn andre typar innlegg, og bidrog til nyfikne på Mastodon.",
  "annual_report.summary.archetype.pollster.name": "Rundspørjaren",
  "annual_report.summary.archetype.replier.desc_public": "{name} svara ofte på innlegg, og pollinerte Mastodon med nye diskusjonar.",
  "annual_report.summary.archetype.replier.desc_self": "Du svara ofte på innlegg, og pollinerte Mastodon med nye diskusjonar.",
  "annual_report.summary.archetype.replier.name": "Sumarfuglen",
  "annual_report.summary.archetype.reveal": "Avslør arketypen min",
  "annual_report.summary.archetype.reveal_description": "Takk for at du er ein del av Mastodon og allheimen! No er det tid for å finna ut kva arketype du var i {year}.",
  "annual_report.summary.archetype.title_public": "Arketypen til {name}",
  "annual_report.summary.archetype.title_self": "Arketypen din",
  "annual_report.summary.close": "Lat att",
  "annual_report.summary.copy_link": "Kopier lenke",
  "annual_report.summary.followers.new_followers": "{count, plural, one {ny fylgjar} other {nye fylgjarar}}",
  "annual_report.summary.highlighted_post.boost_count": "Dette innlegget vart framheva {count, plural, one {ein gong} other {# gonger}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Dette innlegget vart favorittmerka {count, plural, one {ein gong} other {# gonger}}.",
  "annual_report.summary.highlighted_post.reply_count": "Dette innlegget fekk {count, plural, one {eitt svar} other {# svar}}.",
  "annual_report.summary.highlighted_post.title": "Mest populære innlegg",
  "annual_report.summary.most_used_app.most_used_app": "mest brukte app",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "mest brukte emneknagg",
  "annual_report.summary.most_used_hashtag.used_count": "Du brukte denne merkelappen i {count, plural, one {eitt innlegg} other {# innlegg}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} brukte denne merkelappen i {count, plural, one {eitt innlegg} other {# innlegg}}.",
  "annual_report.summary.new_posts.new_posts": "nye innlegg",
  "annual_report.summary.percentile.text": "<topLabel>Du er av dei</topLabel><percentage></percentage><bottomLabel>ivrigaste brukarane på {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Ikkje eit ord til pressa.",
  "annual_report.summary.share_elsewhere": "Del andre stader",
  "annual_report.summary.share_message": "Eg fekk arketypen {archetype}!",
  "annual_report.summary.share_on_mastodon": "Del på Mastodon",
  "attachments_list.unprocessed": "(ubehandla)",
  "audio.hide": "Gøym lyd",
  "block_modal.remote_users_caveat": "Me vil be tenaren {domain} om å respektera di avgjerd. Me kan ikkje garantera at det vert gjort, sidan nokre tenarar kan handtera blokkering ulikt. Offentlege innlegg kan framleis vera synlege for ikkje-innlogga brukarar.",
  "block_modal.show_less": "Vis mindre",
  "block_modal.show_more": "Vis meir",
  "block_modal.they_will_know": "Dei kan sjå at dei er blokkerte.",
  "block_modal.title": "Blokker brukaren?",
  "boost_modal.combo": "Du kan trykkja {combo} for å hoppa over dette neste gong",
  "boost_modal.reblog": "Framhev innlegget?",
  "boost_modal.undo_reblog": "Fjern framhevinga?",
  "bundle_column_error.copy_stacktrace": "Kopier feilrapport",
  "bundle_column_error.error.body": "Den etterspurde sida kan ikke hentast fram. Det kan skuldast ein feil i koden vår eller eit kompatibilitetsproblem.",
  "bundle_column_error.error.title": "Ånei!",
  "bundle_column_error.network.body": "Det oppsto ein feil ved lasting av denne sida. Dette kan skuldast eit midlertidig problem med nettkoplinga eller denne tenaren.",
  "bundle_column_error.network.title": "Nettverksfeil",
  "bundle_column_error.retry": "Prøv igjen",
  "bundle_column_error.return": "Gå heim att",
  "bundle_column_error.routing.body": "Den etterspurde sida vart ikkje funnen. Er du sikker på at URL-adressa er rett?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Lat att",
  "bundle_modal_error.message": "Noko gjekk gale då denne sida vart lasta.",
  "bundle_modal_error.retry": "Prøv igjen",
  "callout.dismiss": "Avvis",
  "carousel.current": "<sr>Side</sr> {current, number} / {max, number}",
  "carousel.slide": "Side {current, number} av {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} tilrådde teikn",
  "character_counter.required": "{currentLength}/{maxLength} teikn",
  "closed_registrations.other_server_instructions": "Sidan Mastodon er desentralisert kan du lage ein brukar på ein anna tenar og framleis interagere med denne.",
  "closed_registrations_modal.description": "Det er ikkje mogleg å opprette ein konto på {domain} nett no, men hugs at du ikkje treng ein konto på akkurat {domain} for å nytte Mastodon.",
  "closed_registrations_modal.find_another_server": "Finn ein annan tenar",
  "closed_registrations_modal.preamble": "Mastodon er desentralisert, så uansett kvar du opprettar ein konto, vil du kunne fylgje og samhandle med alle på denne tenaren. Du kan til og med ha din eigen tenar!",
  "closed_registrations_modal.title": "Registrer deg på Mastodon",
  "collection.share_modal.share_via_post": "Legg ut på Mastodon",
  "collection.share_modal.share_via_system": "Del med…",
  "collection.share_modal.title": "Del ei samling",
  "collection.share_modal.title_new": "Del den nye samlinga di!",
  "collection.share_template_other": "Sjekk denne samlinga: {link}",
  "collection.share_template_own": "Sjekk den nye samlinga mi: {link}",
  "collections.account_count": "{count, plural, one {# konto} other {# kontoar}}",
  "collections.accounts.empty_title": "Denne samlinga er tom",
  "collections.by_account": "av {account_handle}",
  "collections.collection_description": "Skildring",
  "collections.collection_language": "Språk",
  "collections.collection_language_none": "Ingen",
  "collections.collection_name": "Namn",
  "collections.collection_topic": "Emne",
  "collections.confirm_account_removal": "Er du sikker på at du vil fjerna denne brukarkontoen frå samlinga?",
  "collections.content_warning": "Innhaldsåtvaring",
  "collections.continue": "Hald fram",
  "collections.create.accounts_title": "Kven vil du leggja vekt på denne samlinga?",
  "collections.create.basic_details_title": "Grunnleggjande opplysingar",
  "collections.create.steps": "Steg {step}/{total}",
  "collections.create_collection": "Lag ei samling",
  "collections.delete_collection": "Slett samlinga",
  "collections.description_length_hint": "Maks 100 teikn",
  "collections.detail.author_added_you_on_date": "{author} la deg til {date}",
  "collections.detail.loading": "Lastar inn samling…",
  "collections.detail.revoke_inclusion": "Fjern meg",
  "collections.detail.sensitive_content": "Ømtolig innhald",
  "collections.detail.sensitive_note": "Denne samlinga inneheld kontoar og innhald som kan vera ømtolige for nokre menneske.",
  "collections.detail.share": "Del denne samlinga",
  "collections.detail.you_are_in_this_collection": "Du er framheva i denne samlinga",
  "collections.edit_details": "Rediger detaljar",
  "collections.last_updated_at": "Sist oppdatert: {date}",
  "collections.manage_accounts": "Handter kontoar",
  "collections.mark_as_sensitive": "Merk som ømtolig",
  "collections.mark_as_sensitive_hint": "Gøymer skildringa og kontoane i samlinga bak ei innhaldsåtvaring. Namnet på samlinga blir framleis synleg.",
  "collections.name_length_hint": "Maks 40 teikn",
  "collections.new_collection": "Ny samling",
  "collections.report_collection": "Rapporter denne samlinga",
  "collections.revoke_collection_inclusion": "Fjern meg frå denne samlinga",
  "collections.revoke_inclusion.confirmation": "Du er fjerna frå «{collection}»",
  "collections.revoke_inclusion.error": "Noko gjekk gale, prøv att seinare.",
  "collections.search_accounts_max_reached": "Du har nådd grensa for kor mange kontoar du kan leggja til",
  "collections.sensitive": "Ømtolig",
  "collections.topic_hint": "Legg til ein emneknagg som hjelper andre å forstå hovudemnet for denne samlinga.",
  "collections.topic_special_chars_hint": "Spesialteikn vil bli fjerna ved lagring",
  "collections.view_collection": "Sjå samlinga",
  "collections.visibility_public": "Offentleg",
  "collections.visibility_public_hint": "Kan koma opp i søkjeresultat og andre stader der tilrådingar syner.",
  "collections.visibility_title": "Vising",
  "collections.visibility_unlisted": "Ikkje oppført",
  "collections.visibility_unlisted_hint": "Synleg for alle med ei lenke. Gøymt frå søkjeresultat og tilrådingar.",
  "column.about": "Om",
  "column.blocks": "Blokkerte brukarar",
  "column.bookmarks": "Bokmerke",
  "column.community": "Lokal tidsline",
  "column.create_list": "Lag liste",
  "column.direct": "Private omtaler",
  "column.directory": "Sjå gjennom profilar",
  "column.domain_blocks": "Blokkerte domene",
  "column.edit_list": "Rediger liste",
  "column.favourites": "Favorittar",
  "column.firehose": "Tidslinjer",
  "column.firehose_local": "Direktestraum for denne tenaren",
  "column.firehose_singular": "Direktestraum",
  "column.follow_requests": "Fylgjeførespurnadar",
  "column.home": "Heim",
  "column.list_members": "Administrer medlemer på lista",
  "column.lists": "Lister",
  "column.mutes": "Målbundne brukarar",
  "column.notifications": "Varsel",
  "column.pins": "Festa tut",
  "column.public": "Samla tidsline",
  "column_back_button.label": "Attende",
  "column_header.hide_settings": "Gøym innstillingane",
  "column_header.moveLeft_settings": "Flytt kolonne til venstre",
  "column_header.moveRight_settings": "Flytt kolonne til høgre",
  "column_header.pin": "Fest",
  "column_header.show_settings": "Vis innstillingar",
  "column_header.unpin": "Løys",
  "column_search.cancel": "Avbryt",
  "combobox.close_results": "Lukk resultata",
  "combobox.loading": "Lastar",
  "combobox.no_results_found": "Ingen resultat for dette søket",
  "combobox.open_results": "Vis resultat",
  "combobox.results_available": "{count, plural, one {# framlegg} other {# framlegg}}. Bruk opp- og ned-piltastane for å navigera. Trykk Enter for å velja.",
  "community.column_settings.local_only": "Berre lokalt",
  "community.column_settings.media_only": "Berre media",
  "community.column_settings.remote_only": "Berre eksternt",
  "compose.error.blank_post": "Innlegg kan ikkje vera tomme.",
  "compose.language.change": "Byt språk",
  "compose.language.search": "Søk språk...",
  "compose.published.body": "Innlegg publisert.",
  "compose.published.open": "Åpne",
  "compose.saved.body": "Innlegg lagra.",
  "compose_form.direct_message_warning_learn_more": "Lær meir",
  "compose_form.encryption_warning": "Innlegg på Mastodon er ikkje ende-til-ende-krypterte. Ikkje del eventuell ømtolig informasjon via Mastodon.",
  "compose_form.hashtag_warning": "Dette innlegget vert ikkje lista under nokre emneknaggar av di det ikkje er offentleg. Berre offentlege innlegg kan verte søkt opp med emneknagg.",
  "compose_form.lock_disclaimer": "Kontoen din er ikkje {locked}. Kven som helst kan fylgja deg for å sjå innlegga dine.",
  "compose_form.lock_disclaimer.lock": "låst",
  "compose_form.placeholder": "Kva har du på hjarta?",
  "compose_form.poll.duration": "Varigheit for rundspørjing",
  "compose_form.poll.multiple": "Fleirval",
  "compose_form.poll.option_placeholder": "Alternativ {number}",
  "compose_form.poll.single": "Eitt val",
  "compose_form.poll.switch_to_multiple": "Endre rundspørjinga til å tillate fleire val",
  "compose_form.poll.switch_to_single": "Endre rundspørjinga til å tillate berre eitt val",
  "compose_form.poll.type": "Stil",
  "compose_form.publish": "Publiser",
  "compose_form.reply": "Svar",
  "compose_form.save_changes": "Oppdater",
  "compose_form.spoiler.marked": "Fjern innhaldsåtvaring",
  "compose_form.spoiler.unmarked": "Legg til innhaldsåtvaring",
  "compose_form.spoiler_placeholder": "Innhaldsåtvaring (valfritt)",
  "confirmation_modal.cancel": "Avbryt",
  "confirmations.block.confirm": "Blokker",
  "confirmations.delete.confirm": "Slett",
  "confirmations.delete.message": "Er du sikker på at du vil sletta denne statusen?",
  "confirmations.delete.title": "Slett innlegget?",
  "confirmations.delete_collection.confirm": "Slett",
  "confirmations.delete_collection.message": "Du kan ikkje angra denne handlinga.",
  "confirmations.delete_collection.title": "Slett «{name}»?",
  "confirmations.delete_list.confirm": "Slett",
  "confirmations.delete_list.message": "Er du sikker på at du vil sletta denne lista for alltid?",
  "confirmations.delete_list.title": "Slett lista?",
  "confirmations.discard_draft.confirm": "Forkast og hald fram",
  "confirmations.discard_draft.edit.cancel": "Rediger vidare",
  "confirmations.discard_draft.edit.message": "Viss du held fram, vil du forkasta alle endringane du har gjort på dette innlegget.",
  "confirmations.discard_draft.edit.title": "Vil du forkasta endringane på innlegget?",
  "confirmations.discard_draft.post.cancel": "Hald fram med kladden",
  "confirmations.discard_draft.post.message": "Viss du held fram, forkastar du det innlegget du skriv på no.",
  "confirmations.discard_draft.post.title": "Forkast kladden?",
  "confirmations.discard_edit_media.confirm": "Forkast",
  "confirmations.discard_edit_media.message": "Du har ulagra endringar i mediaskildringa eller førehandsvisinga. Vil du forkasta dei likevel?",
  "confirmations.follow_to_list.confirm": "Fylg og legg til lista",
  "confirmations.follow_to_list.message": "Du må fylgja {name} for å leggja dei til ei liste.",
  "confirmations.follow_to_list.title": "Vil du fylgja brukaren?",
  "confirmations.logout.confirm": "Logg ut",
  "confirmations.logout.message": "Er du sikker på at du vil logga ut?",
  "confirmations.logout.title": "Logg ut?",
  "confirmations.missing_alt_text.confirm": "Legg til alternativ tekst",
  "confirmations.missing_alt_text.message": "Posten din inneheld media utan alternativ-tekst. Det å leggje til skildringar hjelper med gjere innhaldet ditt tilgjengeleg for fleire personar.",
  "confirmations.missing_alt_text.secondary": "Publiser likevel",
  "confirmations.missing_alt_text.title": "Legg til alternativ tekst?",
  "confirmations.mute.confirm": "Demp",
  "confirmations.private_quote_notify.cancel": "Tilbake til redigeringa",
  "confirmations.private_quote_notify.confirm": "Legg ut innlegget",
  "confirmations.private_quote_notify.do_not_show_again": "Ikkje vis dette fleire gonger",
  "confirmations.private_quote_notify.message": "Personen du siterer, og andre som er nemnde i innlegget, vil få varsel og kan sjå innlegget ditt, sjølv om dei ikkje fylgjer deg.",
  "confirmations.private_quote_notify.title": "Del med fylgjarar og folk som er nemnde?",
  "confirmations.quiet_post_quote_info.dismiss": "Ikkje minn meg på det att",
  "confirmations.quiet_post_quote_info.got_it": "Greitt",
  "confirmations.quiet_post_quote_info.message": "Når du siterer eit stille offentleg innlegg, blir innlegget ditt gøymt frå offentlege populære tidsliner.",
  "confirmations.quiet_post_quote_info.title": "Å sitera stille offentlege innlegg",
  "confirmations.redraft.confirm": "Slett & skriv på nytt",
  "confirmations.redraft.message": "Er du sikker på at du vil sletta denne statusen og skriva han på nytt? Då misser du favorittar og framhevingar, og svar til det opprinnelege innlegget vert foreldrelause.",
  "confirmations.redraft.title": "Slett og skriv på nytt?",
  "confirmations.remove_from_followers.confirm": "Fjern fylgjar",
  "confirmations.remove_from_followers.message": "{name} vil ikkje fylgja deg meir. Vil du halda fram?",
  "confirmations.remove_from_followers.title": "Fjern fylgjar?",
  "confirmations.revoke_collection_inclusion.confirm": "Fjern meg",
  "confirmations.revoke_collection_inclusion.message": "Denne handlinga er endeleg, og kuratoren kan ikkje leggja deg til samlinga på nytt seinare.",
  "confirmations.revoke_collection_inclusion.title": "Vil du fjerna deg sjølv frå denne samlinga?",
  "confirmations.revoke_quote.confirm": "Fjern innlegget",
  "confirmations.revoke_quote.message": "Du kan ikkje angra denne handlinga.",
  "confirmations.revoke_quote.title": "Fjern innlegget?",
  "confirmations.unblock.confirm": "Opphev blokkeringa",
  "confirmations.unblock.title": "Opphev blokkeringa av {name}?",
  "confirmations.unfollow.confirm": "Slutt å fylgja",
  "confirmations.unfollow.title": "Slutt å fylgja {name}?",
  "confirmations.withdraw_request.confirm": "Trekk attende førespurnad",
  "confirmations.withdraw_request.title": "Trekkja tilbake førespurnaden om å fylgja {name}?",
  "content_warning.hide": "Gøym innlegg",
  "content_warning.show": "Vis likevel",
  "content_warning.show_more": "Vis meir",
  "content_warning.show_short": "Vis",
  "conversation.delete": "Slett samtale",
  "conversation.mark_as_read": "Marker som lesen",
  "conversation.open": "Sjå samtale",
  "conversation.with": "Med {names}",
  "copy_icon_button.copied": "Kopiert til utklippstavla",
  "copy_icon_button.copy_this_text": "Kopier til utklippstavla",
  "copypaste.copied": "Kopiert",
  "copypaste.copy_to_clipboard": "Kopier til utklippstavla",
  "directory.federated": "Frå den kjende allheimen",
  "directory.local": "Berre frå {domain}",
  "directory.new_arrivals": "Nyleg tilkomne",
  "directory.recently_active": "Nyleg aktive",
  "disabled_account_banner.account_settings": "Kontoinnstillingar",
  "disabled_account_banner.text": "Kontoen din, {disabledAccount} er for tida deaktivert.",
  "dismissable_banner.community_timeline": "Dette er dei nylegaste offentlege innlegga frå personar med kontoar frå {domain}.",
  "dismissable_banner.dismiss": "Avvis",
  "dismissable_banner.public_timeline": "Dette er dei nyaste offentlege innlegga frå menneske på allheimen som folk på {domain} fylgjer.",
  "domain_block_modal.block": "Blokker tenaren",
  "domain_block_modal.block_account_instead": "Blokker @{name} i staden",
  "domain_block_modal.they_can_interact_with_old_posts": "Folk på denne tenaren kan samhandla med dei gamle innlegga dine.",
  "domain_block_modal.they_cant_follow": "Ingen på denne tenaren kan fylgja deg.",
  "domain_block_modal.they_wont_know": "Dei veit ikkje at dei er blokkerte.",
  "domain_block_modal.title": "Blokker domenet?",
  "domain_block_modal.you_will_lose_num_followers": "Du vil mista {followersCount, plural, one {{followersCountDisplay} fylgjar} other {{followersCountDisplay} fylgjarar}} og {followingCount, plural, one {{followingCountDisplay} person du fylgjer} other {{followingCountDisplay} folk du fylgjer}}.",
  "domain_block_modal.you_will_lose_relationships": "Du vil mista alle fylgjarar og folk du fylgjer på denne tenaren.",
  "domain_block_modal.you_wont_see_posts": "Du vil ikkje sjå innlegg eller varslingar frå brukarar på denne tenaren.",
  "domain_pill.activitypub_lets_connect": "Den lar deg kople til og samhandle med folk ikkje berre på Mastodon, men òg på tvers av forskjellige sosiale appar.",
  "domain_pill.activitypub_like_language": "ActivityPub er som språket Mastodon snakkar med andre sosiale nettverk.",
  "domain_pill.server": "Tenar",
  "domain_pill.their_handle": "Deira handtak:",
  "domain_pill.their_server": "Deira digitale heim, som alle innlegga deira bur.",
  "domain_pill.their_username": "Deira unike identifikator på serveren deira. Det er mogleg å finne brukarar med same brukarnamn på forskjellige tenarar.",
  "domain_pill.username": "Brukarnamn",
  "domain_pill.whats_in_a_handle": "Kva er i eit handtak?",
  "domain_pill.who_they_are": "Sidan handtak seier kven nokon er og kvar dei er, kan du interagere med folk på tvers av det sosiale nettverket av <button>plattformar som støttar ActivityPub</button>.",
  "domain_pill.who_you_are": "Sidan handtaket ditt seier kven du er og kvar du er, kan folk interagere med deg på tvers av det sosiale nettverket av <button>plattformar som støttar ActivityPub</button>.",
  "domain_pill.your_handle": "Handtaket ditt:",
  "domain_pill.your_server": "Din digitale heim, der alle innlegga dine bur. Liker du ikkje dette? Byt til ein ny tenar når som helst og ta med fylgjarane dine òg.",
  "domain_pill.your_username": "Din unike identifikator på denne tenaren. Det er mogleg å finne brukarar med same brukarnamn på forskjellige tenarar.",
  "dropdown.empty": "Vel eit alternativ",
  "email_subscriptions.email": "Epost",
  "email_subscriptions.form.action": "Abonner",
  "email_subscriptions.form.bottom": "Få innlegg i innboksen din utan å laga ein Mastodon-konto. Meld deg av når du vil. Sjå <a>personvernsida</a> for meir info.",
  "email_subscriptions.form.title": "Meld deg på epostoppdateringar frå {name}",
  "email_subscriptions.submitted.lead": "Sjekk innboksen din for ein epost om korleis du fullfører abonnementet på epostoppdateringar.",
  "email_subscriptions.submitted.title": "Eitt steg til",
  "email_subscriptions.validation.email.blocked": "Blokkert epostleverandør",
  "email_subscriptions.validation.email.invalid": "Ugyldig epostadresse",
  "embed.instructions": "Bygg inn denne statusen på nettsida di ved å kopiera koden nedanfor.",
  "embed.preview": "Slik kjem det til å sjå ut:",
  "emoji_button.activity": "Aktivitet",
  "emoji_button.clear": "Tøm",
  "emoji_button.custom": "Tilpassa",
  "emoji_button.flags": "Flagg",
  "emoji_button.food": "Mat & drikke",
  "emoji_button.label": "Legg til emoji",
  "emoji_button.nature": "Natur",
  "emoji_button.not_found": "Finn ingen samsvarande emojiar",
  "emoji_button.objects": "Objekt",
  "emoji_button.people": "Folk",
  "emoji_button.recent": "Ofte brukt",
  "emoji_button.search": "Søk...",
  "emoji_button.search_results": "Søkeresultat",
  "emoji_button.symbols": "Symbol",
  "emoji_button.travel": "Reise & stader",
  "empty_column.account_featured_self.no_collections_button": "Lag ei samling",
  "empty_column.account_featured_self.pre_collections": "Fylg med for å sjå samlingar",
  "empty_column.account_featured_unknown.other": "Denne kontoen har ikkje valt ut noko enno.",
  "empty_column.account_hides_collections": "Denne brukaren har valt å ikkje gjere denne informasjonen tilgjengeleg",
  "empty_column.account_suspended": "Kontoen er utestengd",
  "empty_column.account_timeline": "Ingen tut her!",
  "empty_column.account_unavailable": "Profil ikkje tilgjengeleg",
  "empty_column.blocks": "Du har ikkje blokkert nokon enno.",
  "empty_column.bookmarked_statuses": "Du har ikkje lagra noko bokmerke enno. Når du set bokmerke på eit innlegg, dukkar det opp her.",
  "empty_column.community": "Den lokale tidslina er tom. Skriv noko offentleg å få ballen til å rulle!",
  "empty_column.direct": "Du har ingen private omtaler enda. Etter du har sendt eller mottatt en, så vil den dukke opp her.",
  "empty_column.disabled_feed": "Administratorane på tenaren din har skrudd av denne straumen.",
  "empty_column.domain_blocks": "Det er ingen blokkerte domene enno.",
  "empty_column.explore_statuses": "Ingenting er populært nett no. Prøv att seinare!",
  "empty_column.favourited_statuses": "Du har ingen favoritt-statusar ennå. Når du merkjer ein som favoritt, dukkar han opp her.",
  "empty_column.favourites": "Ingen har merkt denne statusen som favoritt enno. Når nokon gjer det, dukkar dei opp her.",
  "empty_column.follow_requests": "Ingen har spurt om å fylgja deg enno. Når nokon gjer det, vil det dukka opp her.",
  "empty_column.followed_tags": "Du fylgjer ingen emneknaggar enno. Når du gjer det, vil dei syna her.",
  "empty_column.hashtag": "Det er ingenting i denne emneknaggen enno.",
  "empty_column.home": "Heime-tidslina di er tom! Fylg fleire folk for å fylla ho med innhald. {suggestions}.",
  "empty_column.list": "Det er ingenting i denne lista enno. Når medlemer av denne lista legg ut nye statusar, så dukkar dei opp her.",
  "empty_column.mutes": "Du har ikkje målbunde nokon enno.",
  "empty_column.notification_requests": "Ferdig! Her er det ingenting. Når du får nye varsel, kjem dei opp her slik du har valt.",
  "empty_column.notifications": "Du har ingen varsel enno. Kommuniser med andre for å starte samtalen.",
  "empty_column.public": "Det er ingenting her! Skriv noko offentleg, eller fylg brukarar frå andre tenarar manuelt for å få meir her",
  "empty_state.no_results": "Ingen resultat",
  "error.no_hashtag_feed_access": "Bli medlem eller logg inn for å sjå og fylgja denne emneknaggen.",
  "error.unexpected_crash.explanation": "På grunn av eit nettlesarkompatibilitetsproblem eller ein feil i koden vår, kunne ikkje denne sida bli vist slik den skal.",
  "error.unexpected_crash.explanation_addons": "Denne sida kunne ikkje visast som den skulle. Feilen kjem truleg frå ei nettleserutviding eller frå automatiske omsetjingsverktøy.",
  "error.unexpected_crash.next_steps": "Prøv å lasta inn sida på nytt. Hjelper ikkje dette kan du framleis nytta Mastodon i ein annan nettlesar eller app.",
  "error.unexpected_crash.next_steps_addons": "Prøv å skru dei av og last inn sida på nytt. Hjelper ikkje det kan du framleis bruka Mastodon i ein annan nettlesar eller app.",
  "errors.unexpected_crash.copy_stacktrace": "Kopier stacktrace til utklippstavla",
  "errors.unexpected_crash.report_issue": "Rapporter problem",
  "explore.suggested_follows": "Folk",
  "explore.title": "Populært",
  "explore.trending_links": "Nytt",
  "explore.trending_statuses": "Innlegg",
  "explore.trending_tags": "Emneknaggar",
  "featured_carousel.current": "<sr>Innlegg</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Festa innlegg} other {Festa innlegg}}",
  "featured_carousel.slide": "Innlegg {current, number} av {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "I det siste har du skrive om {items}. Vil du leggja til desse som framheva emneknaggar?",
  "featured_tags.suggestions.add": "Legg til",
  "featured_tags.suggestions.added": "Handter dei framheva emneknaggane dine når som helst under <link>Rediger profil > Framheva emneknaggar</link>.",
  "featured_tags.suggestions.dismiss": "Nei takk",
  "filter_modal.added.context_mismatch_explanation": "Denne filterkategorien gjeld ikkje i den samanhengen du har lese dette innlegget. Viss du vil at innlegget skal filtrerast i denne samanhengen òg, må du endra filteret.",
  "filter_modal.added.context_mismatch_title": "Konteksten passar ikkje!",
  "filter_modal.added.expired_explanation": "Denne filterkategorien har gått ut på dato. Du må endre best før datoen for at den skal gjelde.",
  "filter_modal.added.expired_title": "Filteret har gått ut på dato!",
  "filter_modal.added.review_and_configure": "For å gjennomgå og konfigurere denne filterkategorien, gå til {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Filterinnstillingar",
  "filter_modal.added.settings_link": "innstillingar",
  "filter_modal.added.short_explanation": "Dette innlegget er lagt til i denne filterkategorien: {title}.",
  "filter_modal.added.title": "Filteret er lagt til!",
  "filter_modal.select_filter.context_mismatch": "gjeld ikkje i denne samanhengen",
  "filter_modal.select_filter.expired": "gått ut på dato",
  "filter_modal.select_filter.prompt_new": "Ny kategori: {name}",
  "filter_modal.select_filter.search": "Søk eller opprett",
  "filter_modal.select_filter.subtitle": "Bruk ein eksisterande kategori eller opprett ein ny",
  "filter_modal.select_filter.title": "Filtrer dette innlegget",
  "filter_modal.title.status": "Filtrer eit innlegg",
  "filter_warning.matches_filter": "Passar med filteret «<span>{title}</span>»",
  "filtered_notifications_banner.pending_requests": "Frå {count, plural, =0 {ingen} one {éin person} other {# personar}} du kanskje kjenner",
  "filtered_notifications_banner.title": "Filtrerte varslingar",
  "firehose.all": "Alle",
  "firehose.local": "Denne tenaren",
  "firehose.remote": "Andre tenarar",
  "follow_request.authorize": "Autoriser",
  "follow_request.reject": "Avvis",
  "follow_requests.unlocked_explanation": "Sjølv om kontoen din ikkje er låst tenkte dei som driv {domain} at du kanskje ville gå gjennom førespurnadar frå desse kontoane manuelt.",
  "follow_suggestions.curated_suggestion": "Utvalt av staben",
  "follow_suggestions.dismiss": "Ikkje vis igjen",
  "follow_suggestions.featured_longer": "Hanplukka av gjengen på {domain}",
  "follow_suggestions.friends_of_friends_longer": "Populært hjå dei du fylgjer",
  "follow_suggestions.hints.featured": "Denne profilen er handplukka av folka på {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Denne profilen er populær hjå dei du fylgjer.",
  "follow_suggestions.hints.most_followed": "Mange på {domain} fylgjer denne profilen.",
  "follow_suggestions.hints.most_interactions": "Denne profilen har nyss fått mykje merksemd på {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Denne profilen liknar på dei andre profilane du har fylgt i det siste.",
  "follow_suggestions.personalized_suggestion": "Personleg forslag",
  "follow_suggestions.popular_suggestion": "Populært forslag",
  "follow_suggestions.popular_suggestion_longer": "Populært på {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Liknar på profilar du har fylgt i det siste",
  "follow_suggestions.view_all": "Vis alle",
  "follow_suggestions.who_to_follow": "Kven du kan fylgja",
  "followed_tags": "Fylgde emneknaggar",
  "followers.hide_other_followers": "Denne personen har valt å ikkje syna dei andre fylgjarane sine",
  "followers.title": "Fylgjer {name}",
  "following.hide_other_following": "Denne personen har valt å ikkje syna kven andre dei fylgjer",
  "following.title": "Fylgd av {name}",
  "footer.about": "Om",
  "footer.about_mastodon": "Om Mastodon",
  "footer.about_server": "Om {domain}",
  "footer.about_this_server": "Om",
  "footer.directory": "Profilmappe",
  "footer.get_app": "Få appen",
  "footer.keyboard_shortcuts": "Snøggtastar",
  "footer.privacy_policy": "Personvernsreglar",
  "footer.source_code": "Vis kjeldekode",
  "footer.status": "Status",
  "footer.terms_of_service": "Brukarvilkår",
  "form_error.blank": "Feltet kan ikkje vera tomt.",
  "form_field.optional": "(valfritt)",
  "generic.saved": "Lagra",
  "getting_started.heading": "Kom i gang",
  "hashtag.admin_moderation": "Opne moderasjonsgrensesnitt for #{name}",
  "hashtag.browse": "Bla gjennom innlegg i #{hashtag}",
  "hashtag.browse_from_account": "Bla gjennom innlegg frå @{name} i #{hashtag}",
  "hashtag.column_header.tag_mode.all": "og {additional}",
  "hashtag.column_header.tag_mode.any": "eller {additional}",
  "hashtag.column_header.tag_mode.none": "utan {additional}",
  "hashtag.column_settings.select.no_options_message": "Fann ingen forslag",
  "hashtag.column_settings.select.placeholder": "Legg til emneknaggar…",
  "hashtag.column_settings.tag_mode.all": "Alle disse",
  "hashtag.column_settings.tag_mode.any": "Kva som helst av desse",
  "hashtag.column_settings.tag_mode.none": "Ingen av desse",
  "hashtag.column_settings.tag_toggle": "Inkluder fleire emneord for denne kolonna",
  "hashtag.counter_by_accounts": "{count, plural,one {{counter} deltakar} other {{counter} deltakarar}}",
  "hashtag.counter_by_uses": "{count, plural,one {{counter} innlegg} other {{counter} innlegg}}",
  "hashtag.counter_by_uses_today": "{count, plural,one {{counter} innlegg} other {{counter} innlegg}} i dag",
  "hashtag.feature": "Vis på profilen",
  "hashtag.follow": "Fylg emneknagg",
  "hashtag.mute": "Demp @#{hashtag}",
  "hashtag.unfeature": "Ikkje vis på profilen",
  "hashtag.unfollow": "Slutt å fylgje emneknaggen",
  "hashtags.and_other": "…og {count, plural, one {}other {# fleire}}",
  "hints.profiles.followers_may_be_missing": "Kven som fylgjer denne profilen manglar kanskje.",
  "hints.profiles.follows_may_be_missing": "Kven denne profilen fylgjer manglar kanskje.",
  "hints.profiles.posts_may_be_missing": "Nokre innlegg frå denne profilen manglar kanskje.",
  "hints.profiles.see_more_followers": "Sjå fleire fylgjarar på {domain}",
  "hints.profiles.see_more_follows": "Sjå fleire fylgje på {domain}",
  "hints.profiles.see_more_posts": "Sjå fleire innlegg på {domain}",
  "home.column_settings.show_quotes": "Vis sitat",
  "home.column_settings.show_reblogs": "Vis framhevingar",
  "home.column_settings.show_replies": "Vis svar",
  "home.hide_announcements": "Skjul kunngjeringar",
  "home.pending_critical_update.body": "Oppdater mastodontenaren din så snart som mogleg!",
  "home.pending_critical_update.link": "Sjå oppdateringar",
  "home.pending_critical_update.title": "Kritisk sikkerheitsoppdatering er tilgjengeleg!",
  "home.show_announcements": "Vis kunngjeringar",
  "ignore_notifications_modal.disclaimer": "Mastodon kan ikkje informera brukarane at du overser varsla deira. Å oversjå varsel vil ikkje hindra at meldingane blir sende.",
  "ignore_notifications_modal.filter_instead": "Filtrer i staden",
  "ignore_notifications_modal.filter_to_act_users": "Du kan framleis godta, avvisa eller rapportera brukarar",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Å filtrera hjelper til å unngå mogleg forvirring",
  "ignore_notifications_modal.filter_to_review_separately": "Du kan gå gjennom filtrerte varslingar for seg",
  "ignore_notifications_modal.ignore": "Oversjå varsel",
  "ignore_notifications_modal.limited_accounts_title": "Oversjå varsel frå modererte kontoar?",
  "ignore_notifications_modal.new_accounts_title": "Oversjå varsel frå nye kontoar?",
  "ignore_notifications_modal.not_followers_title": "Oversjå varsel frå folk som ikkje fylgjer deg?",
  "ignore_notifications_modal.not_following_title": "Oversjå varsel frå folk du ikkje fylgjer?",
  "ignore_notifications_modal.private_mentions_title": "Oversjå varsel frå masseutsende private omtaler?",
  "info_button.label": "Hjelp",
  "info_button.what_is_alt_text": "<h1>Kva er alternativ tekst?</h1> <p>Alternativ eller skildrande tekst gjev ei skildring av biletet for menneske som har synsvanskar, sein nettilkopling eller dei som ser etter ekstra innhald.</p> <p>Du gjer innhaldet ditt meir tilgjengeleg og forståeleg for alle ved å skriva klåre, presise og nøytrale alt-tekstar.</p> <ul> <li>Skriv om viktige element</li> <li>Oppsummer tekst i bilete</li> <li>Skriv vanlege setningar</li> <li>Unngå unyttige opplysingar</li> <li>Legg vekt på hovudpunkta i innhaldsrike visuelle element, som grafar eller kart</li> </ul>",
  "interaction_modal.action": "For å handla med innlegget til {name}, må du logga inn på den Mastodon-tenaren du bruker.",
  "interaction_modal.go": "Gå",
  "interaction_modal.no_account_yet": "Har du ikkje ein konto enno?",
  "interaction_modal.on_another_server": "På ein annan tenar",
  "interaction_modal.on_this_server": "På denne tenaren",
  "interaction_modal.title": "Logg inn for å halda fram",
  "interaction_modal.username_prompt": "T.d. {example}",
  "intervals.full.days": "{number, plural, one {# dag} other {# dagar}}",
  "intervals.full.hours": "{number, plural, one {# time} other {# timar}}",
  "intervals.full.minutes": "{number, plural, one {# minutt} other {# minutt}}",
  "keyboard_shortcuts.back": "Gå tilbake",
  "keyboard_shortcuts.blocked": "Opne lista over blokkerte brukarar",
  "keyboard_shortcuts.boost": "Framhev innlegg",
  "keyboard_shortcuts.column": "Fokuskolonne",
  "keyboard_shortcuts.compose": "for å fokusera tekstfeltet for skriving",
  "keyboard_shortcuts.description": "Skildring",
  "keyboard_shortcuts.direct": "Opne spalta med private omtalar",
  "keyboard_shortcuts.down": "Flytt nedover i lista",
  "keyboard_shortcuts.enter": "Opne innlegg",
  "keyboard_shortcuts.explore": "Opne «populært»-tidslina",
  "keyboard_shortcuts.favourite": "Marker innlegget som favoritt",
  "keyboard_shortcuts.favourites": "Opne favorittlista",
  "keyboard_shortcuts.federated": "Opne den samla tidslina",
  "keyboard_shortcuts.heading": "Snøggtastar",
  "keyboard_shortcuts.home": "Opne heimetidslina",
  "keyboard_shortcuts.hotkey": "Snøggtast",
  "keyboard_shortcuts.legend": "Vis denne forklaringa",
  "keyboard_shortcuts.load_more": "Fokuser på «Last meir»-knappen",
  "keyboard_shortcuts.local": "Opne lokal tidsline",
  "keyboard_shortcuts.mention": "Nemn forfattaren",
  "keyboard_shortcuts.muted": "Opne liste over målbundne brukarar",
  "keyboard_shortcuts.my_profile": "Opne profilen din",
  "keyboard_shortcuts.notifications": "Opne varselkolonna",
  "keyboard_shortcuts.open_media": "Opne media",
  "keyboard_shortcuts.pinned": "Opne lista over festa tut",
  "keyboard_shortcuts.profile": "Opne forfattaren sin profil",
  "keyboard_shortcuts.quote": "Siter innlegget",
  "keyboard_shortcuts.reply": "Svar på innlegg",
  "keyboard_shortcuts.requests": "Opne lista med fylgjeførespurnader",
  "keyboard_shortcuts.search": "for å fokusera søket",
  "keyboard_shortcuts.spoilers": "Vis/gøym CW-felt",
  "keyboard_shortcuts.start": "Opne kolonna \"kom i gang\"",
  "keyboard_shortcuts.toggle_hidden": "Vis/gøym tekst bak innhaldsvarsel",
  "keyboard_shortcuts.toggle_sensitivity": "Vis/gøym media",
  "keyboard_shortcuts.toot": "Lag nytt tut",
  "keyboard_shortcuts.top": "Flytt til toppen av lista",
  "keyboard_shortcuts.translate": "å omsetje eit innlegg",
  "keyboard_shortcuts.unfocus": "for å fokusere vekk skrive-/søkefeltet",
  "keyboard_shortcuts.up": "Flytt opp på lista",
  "learn_more_link.got_it": "Forstått",
  "learn_more_link.learn_more": "Lær meir",
  "lightbox.close": "Lukk",
  "lightbox.next": "Neste",
  "lightbox.previous": "Førre",
  "lightbox.zoom_in": "Zoom til faktisk storleik",
  "lightbox.zoom_out": "Vis heile",
  "limited_account_hint.action": "Vis profilen likevel",
  "limited_account_hint.title": "Denne profilen er skjult av moderatorane på {domain}.",
  "link_preview.author": "Av {name}",
  "link_preview.more_from_author": "Meir frå {name}",
  "link_preview.shares": "{count, plural,one {{counter} innlegg} other {{counter} innlegg}}",
  "lists.add_member": "Legg til",
  "lists.add_to_list": "Legg til i liste",
  "lists.add_to_lists": "Legg til {name} i lister",
  "lists.create": "Lag",
  "lists.create_a_list_to_organize": "Lag ei ny liste for å organisera startskjermen din",
  "lists.create_list": "Lag liste",
  "lists.delete": "Slett liste",
  "lists.done": "Ferdig",
  "lists.edit": "Rediger liste",
  "lists.exclusive": "Gøym medlemer frå startskjermen",
  "lists.exclusive_hint": "Viss nokon er på denne lista, blir dei gøymde frå startskjermen slik at du slepp sjå innlegga deira to gonger.",
  "lists.find_users_to_add": "Finn brukarar å leggja til",
  "lists.list_members_count": "{count, plural, one {# medlem} other {# medlemer}}",
  "lists.list_name": "Namn på lista",
  "lists.new_list_name": "Namn på den nye lista",
  "lists.no_lists_yet": "Ingen lister enno.",
  "lists.no_members_yet": "Ingen medlemer enno.",
  "lists.no_results_found": "Fann ingenting.",
  "lists.remove_member": "Fjern",
  "lists.replies_policy.followed": "Alle fylgde brukarar",
  "lists.replies_policy.list": "Medlemar i lista",
  "lists.replies_policy.none": "Ingen",
  "lists.save": "Lagre",
  "lists.search": "Søk",
  "lists.show_replies_to": "Inkluder svar frå listemedlemer til",
  "load_pending": "{count, plural, one {# nytt element} other {# nye element}}",
  "loading_indicator.label": "Lastar…",
  "media_gallery.hide": "Gøym",
  "moved_to_account_banner.text": "Kontoen din, {disabledAccount} er for tida deaktivert fordi du har flytta til {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Ikkje vis varslingar",
  "mute_modal.hide_options": "Gøym val",
  "mute_modal.indefinite": "Til eg avdempar dei",
  "mute_modal.show_options": "Vis val",
  "mute_modal.they_can_mention_and_follow": "Dei kan nemna og fylgja deg, men du vil ikkje sjå dei.",
  "mute_modal.they_wont_know": "Dei veit ikkje at dei er dempa.",
  "mute_modal.title": "Demp brukaren?",
  "mute_modal.you_wont_see_mentions": "Du vil ikkje sjå innlegg som nemner dei.",
  "mute_modal.you_wont_see_posts": "Dei kan framleis sjå innlegga dine, men du vil ikkje sjå deira.",
  "navigation_bar.about": "Om",
  "navigation_bar.account_settings": "Passord og tryggleik",
  "navigation_bar.administration": "Administrasjon",
  "navigation_bar.advanced_interface": "Opne i avansert nettgrensesnitt",
  "navigation_bar.automated_deletion": "Automatisk sletting av innlegg",
  "navigation_bar.blocks": "Blokkerte brukarar",
  "navigation_bar.bookmarks": "Bokmerke",
  "navigation_bar.collections": "Samlingar",
  "navigation_bar.direct": "Private omtaler",
  "navigation_bar.domain_blocks": "Skjulte domene",
  "navigation_bar.favourites": "Favorittar",
  "navigation_bar.filters": "Målbundne ord",
  "navigation_bar.follow_requests": "Fylgjeførespurnader",
  "navigation_bar.followed_tags": "Fylgde emneknaggar",
  "navigation_bar.follows_and_followers": "Fylgjer og fylgjarar",
  "navigation_bar.import_export": "Import og eksport",
  "navigation_bar.lists": "Lister",
  "navigation_bar.live_feed_local": "Direktestraum (lokal)",
  "navigation_bar.live_feed_public": "Direktestraum (allheimen)",
  "navigation_bar.logout": "Logg ut",
  "navigation_bar.moderation": "Moderering",
  "navigation_bar.more": "Meir",
  "navigation_bar.mutes": "Målbundne brukarar",
  "navigation_bar.opened_in_classic_interface": "Innlegg, kontoar, og enkelte andre sider blir opna som standard i det klassiske webgrensesnittet.",
  "navigation_bar.preferences": "Innstillingar",
  "navigation_bar.privacy_and_reach": "Personvern og rekkjevidd",
  "navigation_bar.search": "Søk",
  "navigation_bar.search_trends": "Søk / Populært",
  "navigation_panel.collapse_followed_tags": "Gøym menyen over emneknaggar du fylgjer",
  "navigation_panel.collapse_lists": "Gøym listemenyen",
  "navigation_panel.expand_followed_tags": "Utvid menyen over emneknaggar du fylgjer",
  "navigation_panel.expand_lists": "Utvid listemenyen",
  "not_signed_in_indicator.not_signed_in": "Du må logga inn for å få tilgang til denne ressursen.",
  "notification.admin.report": "{name} rapporterte {target}",
  "notification.admin.report_account": "{name} rapporterte {count, plural, one {eitt innlegg} other {# innlegg}} frå {target} for {category}",
  "notification.admin.report_account_other": "{name} rapporterte {count, plural, one {eitt innlegg} other {# innlegg}} frå {target}",
  "notification.admin.report_statuses": "{name} rapporterte {target} for {category}",
  "notification.admin.report_statuses_other": "{name} rapporterte {target}",
  "notification.admin.sign_up": "{name} er registrert",
  "notification.admin.sign_up.name_and_others": "{name} og {count, plural, one {# annan} other {# andre}} vart med",
  "notification.annual_report.message": "#Året ditt for {year} ventar! Sjå kva som skjedde i løpet av Mastodon-året ditt!",
  "notification.annual_report.view": "Sjå #Året ditt",
  "notification.favourite": "{name} markerte innlegget ditt som favoritt",
  "notification.favourite.name_and_others_with_link": "{name} og <a>{count, plural, one {# annan} other {# andre}}</a> favorittmerka innlegget ditt",
  "notification.favourite_pm": "{name} favorittmerka den private omtalen din",
  "notification.favourite_pm.name_and_others_with_link": "{name} og <a>{count, plural, one {# annan} other {# andre}}</a> favorittmerka den private omtalen din",
  "notification.follow": "{name} fylgde deg",
  "notification.follow.name_and_others": "{name} og <a>{count, plural, one {# annan} other {# andre}}</a> fylgde deg",
  "notification.follow_request": "{name} har bedt om å fylgja deg",
  "notification.follow_request.name_and_others": "{name} og {count, plural, one {# annan} other {# andre}} har spurt om å fylgja deg",
  "notification.label.mention": "Omtale",
  "notification.label.private_mention": "Privat omtale",
  "notification.label.private_reply": "Privat svar",
  "notification.label.quote": "{name} siterte innlegget ditt",
  "notification.label.reply": "Svar",
  "notification.mention": "Omtale",
  "notification.mentioned_you": "{name} nemnde deg",
  "notification.moderation-warning.learn_more": "Lær meir",
  "notification.moderation_warning": "Du har mottatt ei moderasjonsåtvaring",
  "notification.moderation_warning.action_delete_statuses": "Nokre av innlegga dine har blitt fjerna.",
  "notification.moderation_warning.action_disable": "Kontoen din har blitt deaktivert.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Nokre av innlegga dine har blitt markert som sensitive.",
  "notification.moderation_warning.action_none": "Kontoen din har mottatt ei moderasjonsåtvaring.",
  "notification.moderation_warning.action_sensitive": "Innlegga dine vil bli markerte som sensitive frå no av.",
  "notification.moderation_warning.action_silence": "Kontoen din har blitt avgrensa.",
  "notification.moderation_warning.action_suspend": "Kontoen din har blitt suspendert.",
  "notification.own_poll": "Rundspørjinga di er ferdig",
  "notification.poll": "Ei rundspørjing du røysta i er ferdig",
  "notification.quoted_update": "{name} redigerte eit innlegg du har sitert",
  "notification.reblog": "{name} framheva innlegget ditt",
  "notification.reblog.name_and_others_with_link": "{name} og <a>{count, plural, one {# annan} other {# andre}}</a> framheva innlegget ditt",
  "notification.relationships_severance_event": "Tapte samband med {name}",
  "notification.relationships_severance_event.account_suspension": "Ein administrator på {from} har utvist {target}, som tyder at du ikkje lenger får oppdateringar frå dei eller kan samhandla med dei.",
  "notification.relationships_severance_event.domain_block": "Ein administrator på {from} har blokkert {target}, inkludert {followersCount} av fylgjarane dine og {followingCount, plural, one {# konto} other {# kontoar}} du fylgjer.",
  "notification.relationships_severance_event.learn_more": "Lær meir",
  "notification.relationships_severance_event.user_domain_block": "Du har blokkert {target}, fjerna {followersCount} av fylgjarane dine og {followingCount, plural, one {# konto} other {# kontoar}} du fylgjer.",
  "notification.status": "{name} la nettopp ut",
  "notification.update": "{name} redigerte eit innlegg",
  "notification_requests.accept": "Godkjenn",
  "notification_requests.accept_multiple": "{count, plural, one {Godta # førespurnad…} other {Godta # førespurnader…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Godta førespurnad} other {Godta førespurnader}}",
  "notification_requests.confirm_accept_multiple.message": "Du er i ferd med å godta {count, plural, one {ein førespurnad om varsling} other {# førespurnader om varsling}}. Er du sikker på at du vil halda fram?",
  "notification_requests.confirm_accept_multiple.title": "Godta førespurnader om varsling?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Avvis førespurnad} other {Avvis førespurnader}}",
  "notification_requests.confirm_dismiss_multiple.message": "Du er i ferd med å avvisa {count, plural, one {ein førespurnad om varsel} other {# førespurnader om varsel}}. Det blir ikkje lett å få tilgang til {count, plural, one {han} other {dei}} att. Er du sikker på at du vil halda fram?",
  "notification_requests.confirm_dismiss_multiple.title": "Avvis førespurnader om varsel?",
  "notification_requests.dismiss": "Avvis",
  "notification_requests.dismiss_multiple": "{count, plural, one {Avvis # førespurnad…} other {Avvis # førespurnader…}}",
  "notification_requests.edit_selection": "Rediger",
  "notification_requests.exit_selection": "Ferdig",
  "notification_requests.explainer_for_limited_account": "Varsla frå denne kontoen er filtrerte ut fordi ein moderator har avgrensa kontoen.",
  "notification_requests.explainer_for_limited_remote_account": "Varla frå denne kontoen er filtrerte ut fordi ein moderator har avgrensa kontoen eller tenaren.",
  "notification_requests.maximize": "Maksimer",
  "notification_requests.minimize_banner": "Minimer banneret for filtrerte varsel",
  "notification_requests.notifications_from": "Varslingar frå {name}",
  "notification_requests.title": "Filtrerte varslingar",
  "notification_requests.view": "Sjå varsel",
  "notifications.clear": "Tøm varsel",
  "notifications.clear_confirmation": "Er du sikker på at du vil fjerna alle varsla dine for alltid?",
  "notifications.clear_title": "Tøm varsel?",
  "notifications.column_settings.admin.report": "Nye rapportar:",
  "notifications.column_settings.admin.sign_up": "Nyleg registrerte:",
  "notifications.column_settings.alert": "Skrivebordsvarsel",
  "notifications.column_settings.favourite": "Favorittar:",
  "notifications.column_settings.filter_bar.advanced": "Vis alle kategoriar",
  "notifications.column_settings.filter_bar.category": "Snøggfilterline",
  "notifications.column_settings.follow": "Nye fylgjarar:",
  "notifications.column_settings.follow_request": "Ny fylgjarførespurnader:",
  "notifications.column_settings.group": "Gruppe",
  "notifications.column_settings.mention": "Omtalar:",
  "notifications.column_settings.poll": "Røysteresultat:",
  "notifications.column_settings.push": "Pushvarsel",
  "notifications.column_settings.quote": "Sitat:",
  "notifications.column_settings.reblog": "Framhevingar:",
  "notifications.column_settings.show": "Vis i kolonne",
  "notifications.column_settings.sound": "Spel av lyd",
  "notifications.column_settings.status": "Nye tut:",
  "notifications.column_settings.unread_notifications.category": "Uleste varsel",
  "notifications.column_settings.unread_notifications.highlight": "Framhev ulesne varsel",
  "notifications.column_settings.update": "Redigeringar:",
  "notifications.filter.all": "Alle",
  "notifications.filter.boosts": "Framhevingar",
  "notifications.filter.favourites": "Favorittar",
  "notifications.filter.follows": "Fylgjer",
  "notifications.filter.mentions": "Omtalar",
  "notifications.filter.polls": "Røysteresultat",
  "notifications.filter.statuses": "Oppdateringar frå folk du fylgjer",
  "notifications.grant_permission": "Gje løyve.",
  "notifications.group": "{count} varsel",
  "notifications.mark_as_read": "Marker alle varsel som lesne",
  "notifications.permission_denied": "Skrivebordsvarsel er ikkje tilgjengelege på grunn av at nettlesaren tidlegare ikkje har fått naudsynte rettar til å vise dei",
  "notifications.permission_denied_alert": "Sidan nettlesaren tidlegare har blitt nekta naudsynte rettar, kan ikkje skrivebordsvarsel aktiverast",
  "notifications.permission_required": "Skrivebordsvarsel er utilgjengelege fordi naudsynte rettar ikkje er gitt.",
  "notifications.policy.accept": "Godta",
  "notifications.policy.accept_hint": "Vis i varsla",
  "notifications.policy.drop": "Oversjå",
  "notifications.policy.drop_hint": "Send ut i endeløysa så det aldri kjem att",
  "notifications.policy.filter": "Filtrer",
  "notifications.policy.filter_hint": "Send til innboksen for filtrerte varsel",
  "notifications.policy.filter_limited_accounts_hint": "Avgrensa av moderatorar på tenaren",
  "notifications.policy.filter_limited_accounts_title": "Modererte kontoar",
  "notifications.policy.filter_new_accounts.hint": "Skrive siste {days, plural, one {dag} other {# dagar}}",
  "notifications.policy.filter_new_accounts_title": "Nye brukarkontoar",
  "notifications.policy.filter_not_followers_hint": "Inkludert folk som har fylgt deg mindre enn {days, plural, one {ein dag} other {# dagar}}",
  "notifications.policy.filter_not_followers_title": "Folk som ikkje fylgjer deg",
  "notifications.policy.filter_not_following_hint": "Til du godkjenner dei manuelt",
  "notifications.policy.filter_not_following_title": "Folk du ikkje fylgjer",
  "notifications.policy.filter_private_mentions_hint": "Filtrert viss det ikkje er eit svar på dine eigne omtalar eller viss du fylgjer avsendaren",
  "notifications.policy.filter_private_mentions_title": "Masseutsende private omtalar",
  "notifications.policy.title": "Handter varsel frå…",
  "notifications_permission_banner.enable": "Skru på skrivebordsvarsel",
  "notifications_permission_banner.how_to_control": "Aktiver skrivebordsvarsel for å få varsel når Mastodon ikkje er open. Du kan nøye bestemme kva samhandlingar som skal føre til skrivebordsvarsel gjennom {icon}-knappen ovanfor etter at varsel er aktivert.",
  "notifications_permission_banner.title": "Gå aldri glipp av noko",
  "onboarding.follows.back": "Tilbake",
  "onboarding.follows.empty": "Me kan ikkje visa deg nokon resultat no. Du kan prøva å søkja eller bla gjennom utforsk-sida for å finna folk å fylgja, eller du kan prøva att seinare.",
  "onboarding.follows.next": "Neste: Set opp profilen din",
  "onboarding.follows.search": "Søk",
  "onboarding.follows.title": "Fylg folk for å koma i gang",
  "onboarding.profile.discoverable": "Gjer profilen min synleg",
  "onboarding.profile.discoverable_hint": "Når du vel å gjera profilen din synleg på Mastodon, vil innlegga dine syna i søkjeresultat og populære innlegg, og profilen din kan bli føreslegen for folk med liknande interesser som deg.",
  "onboarding.profile.display_name": "Synleg namn",
  "onboarding.profile.display_name_hint": "Det fulle namnet eller kallenamnet ditt…",
  "onboarding.profile.finish": "Fullfør",
  "onboarding.profile.note": "Om meg",
  "onboarding.profile.note_hint": "Du kan @nemna folk eller #emneknaggar…",
  "onboarding.profile.title": "Profiloppsett",
  "onboarding.profile.upload_avatar": "Last opp profilbilete",
  "onboarding.profile.upload_header": "Last opp profiltoppbilete",
  "password_confirmation.exceeds_maxlength": "Passordbekreftelsen overskrider den maksimale passordlengden",
  "password_confirmation.mismatching": "Passordene er ulike",
  "picture_in_picture.restore": "Legg den tilbake",
  "poll.closed": "Lukka",
  "poll.refresh": "Oppdater",
  "poll.reveal": "Vis resultat",
  "poll.total_people": "{count, plural, one {# person} other {# folk}}",
  "poll.total_votes": "{count, plural, one {# røyst} other {# røyster}}",
  "poll.vote": "Røyst",
  "poll.voted": "Du røysta på dette svaret",
  "poll.votes": "{votes, plural, one {# røyst} other {# røyster}}",
  "poll_button.add_poll": "Lag ei rundspørjing",
  "poll_button.remove_poll": "Fjern rundspørjing",
  "privacy.change": "Endre personvernet på innlegg",
  "privacy.direct.long": "Alle nemnde i innlegget",
  "privacy.direct.short": "Privat omtale",
  "privacy.private.long": "Berre dei som fylgjer deg",
  "privacy.private.short": "Fylgjarar",
  "privacy.public.long": "Kven som helst på og av Mastodon",
  "privacy.public.short": "Offentleg",
  "privacy.quote.anyone": "{visibility}, det er lov å sitera",
  "privacy.quote.disabled": "{visibility}, ingen kan sitera",
  "privacy.quote.limited": "{visibility}, avgrensa sitat",
  "privacy.unlisted.additional": "Dette er akkurat som offentleg, bortsett frå at innlegga ikkje dukkar opp i direktestraumar eller emneknaggar, i oppdagingar eller Mastodon-søk, sjølv om du har sagt ja til at kontoen skal vera synleg.",
  "privacy.unlisted.long": "Gøymt frå søkjeresultata på Mastodon, og frå populære og offentlege tidsliner",
  "privacy.unlisted.short": "Stille offentleg",
  "privacy_policy.last_updated": "Sist oppdatert {date}",
  "privacy_policy.title": "Personvernsreglar",
  "quote_error.edit": "Du kan ikkje leggja til sitat når du redigerer eit innlegg.",
  "quote_error.poll": "Du kan ikkje sitera meiningsmålingar.",
  "quote_error.private_mentions": "Du kan ikkje sitera direkteomtaler.",
  "quote_error.quote": "Det er berre lov med eitt sitat om gongen.",
  "quote_error.unauthorized": "Du har ikkje løyve til å sitera dette innlegget.",
  "quote_error.upload": "Du kan ikkje sitera medievedlegg.",
  "recommended": "Tilrådd",
  "refresh": "Oppdater",
  "regeneration_indicator.please_stand_by": "Vent litt.",
  "regeneration_indicator.preparing_your_home_feed": "Gjer klar startskjermen din…",
  "relative_time.days": "{number}dg",
  "relative_time.full.days": "{number, plural, one {# dag} other {# dagar}} sidan",
  "relative_time.full.hours": "{number, plural, one {# time} other {# timar}} sidan",
  "relative_time.full.just_now": "nett no",
  "relative_time.full.minutes": "{number, plural, one {# minutt} other {# minutt}} sidan",
  "relative_time.full.seconds": "{number, plural, one {# sekund} other {# sekund}} sidan",
  "relative_time.hours": "{number}t",
  "relative_time.just_now": "no",
  "relative_time.minutes": "{number}min",
  "relative_time.seconds": "{number}sek",
  "relative_time.today": "i dag",
  "remove_quote_hint.button_label": "Greitt",
  "remove_quote_hint.message": "Du kan gjera det på {icon} valmenyen.",
  "remove_quote_hint.title": "Vil du fjerna det siterte innlegget?",
  "reply_indicator.attachments": "{count, plural, one {# vedlegg} other {# vedlegg}}",
  "reply_indicator.cancel": "Avbryt",
  "reply_indicator.poll": "Avstemming",
  "report.block": "Blokker",
  "report.block_explanation": "Du vil ikkje kunne sjå innlegga deira. Dei vil ikkje kunne sjå innlegga dine eller fylgje deg. Dei kan sjå at dei er blokkert.",
  "report.categories.legal": "Juridisk",
  "report.categories.other": "Anna",
  "report.categories.spam": "Søppelpost",
  "report.categories.violation": "Innhaldet bryt med ein eller fleire reglar for tenaren",
  "report.category.subtitle": "Vel det som passar best",
  "report.category.title": "Fortel oss kva som skjer med denne {type}",
  "report.category.title_account": "profil",
  "report.category.title_status": "innlegg",
  "report.close": "Ferdig",
  "report.collection_comment": "Kvifor vil du rapportera denne samlinga?",
  "report.comment.title": "Er det noko anna du meiner me bør vite?",
  "report.forward": "Vidaresend til {target}",
  "report.forward_hint": "Kontoen er frå ein annan tenar. Vil du senda ein anonymisert kopi av rapporten dit òg?",
  "report.mute": "Demp",
  "report.mute_explanation": "Du vil ikkje lenger sjå innlegga deira. Dei kan framleis fylgje deg og sjå innlegga dine, men vil ikkje vite at du har valt å ikkje sjå innlegga deira.",
  "report.next": "Neste",
  "report.placeholder": "Tilleggskommentarar",
  "report.reasons.dislike": "Eg likar det ikkje",
  "report.reasons.dislike_description": "Det er ikkje noko du ønsker å sjå",
  "report.reasons.legal": "Det er ulovleg",
  "report.reasons.legal_description": "Du meinar det bryt lova i landet der du eller tenaren held til",
  "report.reasons.other": "Det er noko anna",
  "report.reasons.other_description": "Problemet passar ikkje inn i dei andre kategoriane",
  "report.reasons.spam": "Det er søppelpost",
  "report.reasons.spam_description": "Skadelege lenker, falskt engasjement og gjentakande svar",
  "report.reasons.violation": "Det bryt tenaren sine reglar",
  "report.reasons.violation_description": "Du veit at den bryt spesifikke reglar",
  "report.rules.subtitle": "Velg det som gjeld",
  "report.rules.title": "Kva reglar vert brotne?",
  "report.statuses.subtitle": "Velg det som gjeld",
  "report.statuses.title": "Er det innlegg som støttar opp under denne rapporten?",
  "report.submission_error": "Greidde ikkje senda rapporten",
  "report.submission_error_details": "Sjekk nettilkoplinga di og prøv att seinare.",
  "report.submit": "Send inn",
  "report.target": "Rapporterer {target}",
  "report.thanks.take_action": "Dette er dei ulike alternativa for å kontrollere kva du ser på Mastodon:",
  "report.thanks.take_action_actionable": "Medan me undersøker rapporteringa, kan du utføre desse handlingane mot @{name}:",
  "report.thanks.title": "Vil du ikkje sjå dette?",
  "report.thanks.title_actionable": "Takk for at du rapporterer, me skal sjå på dette.",
  "report.unfollow": "Slutt å fylgje @{name}",
  "report.unfollow_explanation": "Du fylgjer denne kontoen. Slutt å fylgje dei for ikkje lenger å sjå innlegga deira i heimestraumen din.",
  "report_notification.attached_statuses": "{count, plural, one {{count} innlegg} other {{count} innlegg}} lagt ved",
  "report_notification.categories.legal": "Juridisk",
  "report_notification.categories.legal_sentence": "ulovleg innhald",
  "report_notification.categories.other": "Anna",
  "report_notification.categories.other_sentence": "anna",
  "report_notification.categories.spam": "Søppelpost",
  "report_notification.categories.spam_sentence": "søppel",
  "report_notification.categories.violation": "Regelbrot",
  "report_notification.categories.violation_sentence": "regelbrot",
  "report_notification.open": "Opne rapport",
  "search.clear": "Nullstill søket",
  "search.no_recent_searches": "Ingen søk nylig",
  "search.placeholder": "Søk",
  "search.quick_action.account_search": "Profiler som samsvarer med {x}",
  "search.quick_action.go_to_account": "Gå til profil {x}",
  "search.quick_action.go_to_hashtag": "Gå til emneknagg {x}",
  "search.quick_action.open_url": "Opne adressa i Mastodon",
  "search.quick_action.status_search": "Innlegg som samsvarer med {x}",
  "search.search_or_paste": "Søk eller lim inn URL",
  "search_popout.full_text_search_disabled_message": "Ikkje tilgjengeleg på {domain}.",
  "search_popout.full_text_search_logged_out_message": "Berre tilgjengeleg når du er logga inn.",
  "search_popout.language_code": "ISO-språkkode",
  "search_popout.options": "Søkjealternativ",
  "search_popout.quick_actions": "Hurtighandlinger",
  "search_popout.recent": "Nylige søk",
  "search_popout.specific_date": "konkret dato",
  "search_popout.user": "brukar",
  "search_results.accounts": "Profiler",
  "search_results.all": "Alt",
  "search_results.hashtags": "Emneknaggar",
  "search_results.no_results": "Ingen resultat.",
  "search_results.no_search_yet": "Prøv å søkja etter innlegg, profilar eller emneknaggar.",
  "search_results.see_all": "Sjå alle",
  "search_results.statuses": "Tut",
  "search_results.title": "Søk etter \"{q}\"",
  "server_banner.about_active_users": "Personar som har brukt denne tenaren dei siste 30 dagane (Månadlege Aktive Brukarar)",
  "server_banner.active_users": "aktive brukarar",
  "server_banner.administered_by": "Administrert av:",
  "server_banner.is_one_of_many": "{domain} er ein av dei mange uavhengige Mastodon-tenarane du kan bruka til å delta i Allheimen.",
  "server_banner.server_stats": "Tenarstatistikk:",
  "sign_in_banner.create_account": "Opprett konto",
  "sign_in_banner.follow_anyone": "Fylg kven som helst på tvers av Allheimen og sjå alt i kronologisk rekkjefylgje. Ingen algoritmar, reklame eller klikkfeller.",
  "sign_in_banner.mastodon_is": "Mastodon er den beste måten å fylgja med på det som skjer.",
  "sign_in_banner.sign_in": "Logg inn",
  "sign_in_banner.sso_redirect": "Logg inn eller registrer deg",
  "skip_links.hotkey": "<span>Snøggtast</span> {hotkey}",
  "skip_links.skip_to_content": "Gå til hovudinnhald",
  "skip_links.skip_to_navigation": "Gå til hovudnavigasjon",
  "status.admin_account": "Opne moderasjonsgrensesnitt for @{name}",
  "status.admin_domain": "Opna moderatorgrensesnittet for {domain}",
  "status.admin_status": "Opne denne statusen i moderasjonsgrensesnittet",
  "status.all_disabled": "Framhevingar og sitat er skrudde av",
  "status.block": "Blokker @{name}",
  "status.bookmark": "Set bokmerke",
  "status.cancel_reblog_private": "Opphev framheving",
  "status.cannot_quote": "Du har ikkje løyve til å sitera dette innlegget",
  "status.cannot_reblog": "Du kan ikkje framheva dette innlegget",
  "status.contains_quote": "Inneheld eit sitat",
  "status.context.loading": "Lastar fleire svar",
  "status.context.loading_error": "Kunne ikkje lasta nye svar",
  "status.context.loading_success": "Dei nye svara er lasta",
  "status.context.more_replies_found": "Fann fleire svar",
  "status.context.retry": "Prøv om att",
  "status.context.show": "Vis",
  "status.continued_thread": "Framhald til tråden",
  "status.copy": "Kopier lenke til status",
  "status.delete": "Slett",
  "status.delete.success": "Innlegget er sletta",
  "status.detailed_status": "Detaljert samtalevisning",
  "status.direct": "Nevn @{name} privat",
  "status.direct_indicator": "Privat omtale",
  "status.edit": "Rediger",
  "status.edited": "Sist endra {date}",
  "status.edited_x_times": "Redigert {count, plural, one {{count} gong} other {{count} gonger}}",
  "status.embed": "Få innbyggingskode",
  "status.favourite": "Favoritt",
  "status.favourites_count": "{count, plural, one {{counter} favoritt} other {{counter} favorittar}}",
  "status.filter": "Filtrer dette innlegget",
  "status.history.created": "{name} oppretta {date}",
  "status.history.edited": "{name} redigerte {date}",
  "status.load_more": "Last inn meir",
  "status.media.open": "Klikk for å opne",
  "status.media.show": "Klikk for å vise",
  "status.media_hidden": "Mediet er gøymt",
  "status.mention": "Nemn @{name}",
  "status.more": "Meir",
  "status.mute": "Demp @{name}",
  "status.mute_conversation": "Demp samtale",
  "status.open": "Utvid denne statusen",
  "status.pin": "Fest på profil",
  "status.quote": "Siter",
  "status.quote.cancel": "Avbryt siteringa",
  "status.quote_error.blocked_account_hint.title": "Dette innlegget er gøymt fordi du har blokkert @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Dette innlegget er gøymt fordi du har blokkert {domain}.",
  "status.quote_error.filtered": "Gøymt på grunn av eitt av filtra dine",
  "status.quote_error.limited_account_hint.action": "Vis likevel",
  "status.quote_error.limited_account_hint.title": "Denne kontoen har vorte skjult av moderatorane på {domain}.",
  "status.quote_error.muted_account_hint.title": "Dette innlegget er gøymt fordi du har dempa @{name}.",
  "status.quote_error.not_available": "Innlegget er ikkje tilgjengeleg",
  "status.quote_error.pending_approval": "Innlegget ventar",
  "status.quote_error.pending_approval_popout.body": "På Mastodon kan du kontrollera om folk får sitera deg. Innlegget ditt ventar medan me ventar på at opphavspersonen godkjenner det.",
  "status.quote_error.revoked": "Innlegget er sletta av skribenten",
  "status.quote_followers_only": "Berre fylgjarar kan sitera dette innlegget",
  "status.quote_manual_review": "Skribenten ser gjennom manuelt",
  "status.quote_noun": "Sitat",
  "status.quote_policy_change": "Byt kven som kan sitera",
  "status.quote_post_author": "Siterte eit innlegg av @{name}",
  "status.quote_private": "Du kan ikkje sitera private innlegg",
  "status.quotes.empty": "Ingen har sitert dette innlegget enno. Når nokon gje det, vil det dukka opp her.",
  "status.quotes.local_other_disclaimer": "Sitat som skribenten avviser, vil ikkje syna.",
  "status.quotes.remote_other_disclaimer": "Berre sitat frå {domain} er garanterte å syna her. Sitat som skribenten har avvist, vil ikkje syna.",
  "status.quotes_count": "{count, plural, one {{counter} sitat} other {{counter} sitat}}",
  "status.read_more": "Les meir",
  "status.reblog": "Framhev",
  "status.reblog_or_quote": "Framhev eller siter",
  "status.reblog_private": "Del på nytt med fylgjarane dine",
  "status.reblogged_by": "{name} framheva",
  "status.reblogs.empty": "Ingen har framheva dette tutet enno. Om nokon gjer, så dukkar det opp her.",
  "status.reblogs_count": "{count, plural, one {{counter} framheving} other {{counter} framhevingar}}",
  "status.redraft": "Slett & skriv på nytt",
  "status.remove_bookmark": "Fjern bokmerke",
  "status.remove_favourite": "Fjern frå favorittar",
  "status.remove_quote": "Fjern",
  "status.replied_in_thread": "Svara i tråden",
  "status.replied_to": "Svarte {name}",
  "status.reply": "Svar",
  "status.replyAll": "Svar til tråd",
  "status.report": "Rapporter @{name}",
  "status.request_quote": "Spørsmål om å sitera",
  "status.revoke_quote": "Fjern innlegget mitt frå @{name} sitt innlegg",
  "status.sensitive_warning": "Ømtolig innhald",
  "status.share": "Del",
  "status.show_less_all": "Vis mindre for alle",
  "status.show_more_all": "Vis meir for alle",
  "status.show_original": "Vis original",
  "status.title.with_attachments": "{user} la ut {attachmentCount, plural, one {eitt vedlegg} other {{attachmentCount} vedlegg}}",
  "status.translate": "Omset",
  "status.translated_from_with": "Omsett frå {lang} ved bruk av {provider}",
  "status.uncached_media_warning": "Førehandsvisning er ikkje tilgjengeleg",
  "status.unmute_conversation": "Opphev demping av samtalen",
  "status.unpin": "Løys frå profil",
  "subscribed_languages.lead": "Kun innlegg på valde språk vil bli dukke opp i heimestraumen din og i listene dine etter denne endringa. For å motta innlegg på alle språk, la vere å velje nokon.",
  "subscribed_languages.save": "Lagre endringar",
  "subscribed_languages.target": "Endre abonnerte språk for {target}",
  "tabs_bar.home": "Heim",
  "tabs_bar.menu": "Meny",
  "tabs_bar.notifications": "Varsel",
  "tabs_bar.publish": "Nytt innlegg",
  "tabs_bar.search": "Søk",
  "tag.remove": "Fjern",
  "terms_of_service.effective_as_of": "I kraft frå {date}",
  "terms_of_service.title": "Bruksvilkår",
  "terms_of_service.upcoming_changes_on": "Komande endringar {date}",
  "time_remaining.days": "{number, plural, one {# dag} other {# dagar}} igjen",
  "time_remaining.hours": "{number, plural, one {# time} other {# timar}} igjen",
  "time_remaining.minutes": "{number, plural, one {# minutt} other {# minutt}} igjen",
  "time_remaining.moments": "Kort tid igjen",
  "time_remaining.seconds": "{number, plural, one {# sekund} other {# sekund}} igjen",
  "trends.counter_by_accounts": "{count, plural, one {{counter} person} other {{counter} folk}} siste {days, plural, one {døgnet} other {{days} dagane}}",
  "trends.trending_now": "Populært no",
  "ui.beforeunload": "Kladden din forsvinn om du forlèt Mastodon no.",
  "units.short.billion": "{count}m.ard",
  "units.short.million": "{count}mill",
  "units.short.thousand": "{count}k",
  "upload_area.title": "Dra & slepp for å lasta opp",
  "upload_button.label": "Legg til medium",
  "upload_error.limit": "Du har gått over opplastingsgrensa.",
  "upload_error.poll": "Filopplasting er ikkje lov for rundspørjingar.",
  "upload_error.quote": "Filopplasting er ikkje lov med sitat.",
  "upload_form.drag_and_drop.instructions": "For å plukka opp eit medievedlegg, trykkjer du på mellomrom eller enter. Når du dreg, brukar du piltastane for å flytta vedlegget i den retninga du vil. Deretter trykkjer du mellomrom eller enter att for å sleppa vedlegget på den nye plassen, eller trykk escape for å avbryta.",
  "upload_form.drag_and_drop.on_drag_cancel": "Du avbraut draginga. Medievedlegget {item} vart sleppt.",
  "upload_form.drag_and_drop.on_drag_end": "Medeivedlegget {item} vart sleppt.",
  "upload_form.drag_and_drop.on_drag_over": "Medievedlegget {item} vart flytta.",
  "upload_form.drag_and_drop.on_drag_start": "Plukka opp medievedlegget {item}.",
  "upload_form.edit": "Rediger",
  "upload_progress.label": "Lastar opp...",
  "upload_progress.processing": "Handsamar…",
  "username.taken": "Dette brukernavnet er tatt. Prøv et annet",
  "video.close": "Lukk video",
  "video.download": "Last ned fil",
  "video.exit_fullscreen": "Lukk fullskjerm",
  "video.expand": "Utvid video",
  "video.fullscreen": "Fullskjerm",
  "video.hide": "Gøym video",
  "video.mute": "Demp",
  "video.pause": "Pause",
  "video.play": "Spel av",
  "video.skip_backward": "Hopp bakover",
  "video.skip_forward": "Hopp framover",
  "video.unmute": "Opphev demping",
  "video.volume_down": "Volum ned",
  "video.volume_up": "Volum opp",
  "visibility_modal.button_title": "Vel vising",
  "visibility_modal.direct_quote_warning.text": "Viss du lagrar innstillingane, vil det innebygde sitatet bli omgjort til lenke.",
  "visibility_modal.direct_quote_warning.title": "Du kan ikkje byggja inn sitat i direkteomtaler",
  "visibility_modal.header": "Vising og samhandling",
  "visibility_modal.helper.direct_quoting": "Private omtalar som er skrivne på Mastodon kan ikkje siterast av andre.",
  "visibility_modal.helper.privacy_editing": "Du kan ikkje endra korleis eit innlegg viser når du har lagt det ut.",
  "visibility_modal.helper.privacy_private_self_quote": "Du kan ikkje offentleggjera sjølvsitat av private innlegg.",
  "visibility_modal.helper.private_quoting": "Innlegg som er skrivne på Mastodon og berre for fylgjarar kan ikkje siterast av andre.",
  "visibility_modal.helper.unlisted_quoting": "Når folk siterer deg, vil innlegget deira ikkje syna på populære tidsliner.",
  "visibility_modal.instructions": "Styr kven som kan samhandla med dette innlegget. Du kan òg bruka desse innstillingane på alle framtidige innlegg ved å gå til <link>Innstillingar > Standard for innlegg</link>.",
  "visibility_modal.privacy_label": "Vising",
  "visibility_modal.quote_followers": "Berre fylgjarar",
  "visibility_modal.quote_label": "Kven kan sitera",
  "visibility_modal.quote_nobody": "Berre eg",
  "visibility_modal.quote_public": "Alle",
  "visibility_modal.save": "Lagre"
}
